webpackJsonp([1],{

/***/ "+4/C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+VUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact-form"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.nameRules,"counter":20,"label":"Name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.emailRules,"label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.telephoneRules,"counter":12,"label":"Telephone","required":""},model:{value:(_vm.telephone),callback:function ($$v) {_vm.telephone=$$v},expression:"telephone"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.addressRules,"counter":50,"label":"Address","required":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.projectRules,"counter":20,"label":"Project Name","required":""},model:{value:(_vm.project),callback:function ($$v) {_vm.project=$$v},expression:"project"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.pricerangeRules,"counter":8,"label":"Price Range","data-vv-name":"pricerange"},model:{value:(_vm.pricerange),callback:function ($$v) {_vm.pricerange=$$v},expression:"pricerange"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Comments","textarea":""},model:{value:(_vm.comments),callback:function ($$v) {_vm.comments=$$v},expression:"comments"}})],1),_vm._v(" "),_c('div',{staticClass:"g-recaptcha",attrs:{"id":"g-recaptcha","data-sitekey":_vm.sitekey}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Submit")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+hSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    images: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      activeImage: this.activeIndex,
      imagesPerPage: 8,
      page: 1
    };
  },
  mounted: function mounted() {
    this.page = Math.ceil((this.activeImage + 1) / this.imagesPerPage);
  },

  computed: {
    getImagesPerPage: function getImagesPerPage() {
      return this.images.slice((this.page - 1) * this.imagesPerPage, this.imagesPerPage * this.page);
    }
  },
  methods: {
    showImage: function showImage(index) {
      if (this.page === 1) {
        this.activeImage = index;
      } else {
        this.activeImage = this.imagesPerPage * (this.page - 1) + index;
      }
    },
    showOpacity: function showOpacity(index) {
      if (this.page === 1) {
        if (this.activeImage === index) {
          return true;
        }
        return false;
      } else {
        if (this.activeImage === this.imagesPerPage * (this.page - 1) + index) {
          return true;
        }
        return false;
      }
    },
    handleKeyUp: function handleKeyUp(e) {
      if (e.key === 'ArrowRight') {
        this.handleRightClick();
      } else if (e.key === 'ArrowLeft') {
        this.handleLeftClick();
      }
      // const activeDiv = this.$el.querySelector('#' + this.activeImage)
    },
    handleRightClick: function handleRightClick() {
      if (this.activeImage === this.images.length - 1) {
        this.page = 1;
        this.activeImage = 0;
      } else if (this.activeImage === this.imagesPerPage * this.page - 1) {
        this.activeImage += 1;
        this.page += 1;
      } else {
        this.activeImage += 1;
      }
    },
    handleLeftClick: function handleLeftClick() {
      if (this.activeImage === 0) {
        this.activeImage = this.images.length - 1;
        this.page = Math.ceil(this.images.length / this.imagesPerPage);
      } else if (this.activeImage === (this.page - 1) * this.imagesPerPage) {
        this.activeImage -= 1;
        this.page -= 1;
      } else {
        this.activeImage -= 1;
      }
    },
    handleBlurEvent: function handleBlurEvent() {
      var inputBox = this.$el.querySelector('#hidden-input');
      setTimeout(function () {
        inputBox.focus();
      }, 10);
    },
    pageUp: function pageUp() {
      if (this.page === Math.ceil(this.images.length / this.imagesPerPage)) {
        this.page = 1;
        this.activeImage = 0;
      } else {
        this.activeImage = this.page * this.imagesPerPage;
        this.page += 1;
      }
    },
    pageDown: function pageDown() {
      if (this.page !== 1) {
        this.page -= 1;
        this.activeImage = this.page * this.imagesPerPage - this.imagesPerPage;
      } else {
        this.page = Math.ceil(this.images.length / this.imagesPerPage);
        this.activeImage = this.page * this.imagesPerPage - this.imagesPerPage;
      }
    }
  }
});

/***/ }),

/***/ "+so8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RegistrationForm__ = __webpack_require__("86aM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    }
  },

  components: {
    RegistrationForm: __WEBPACK_IMPORTED_MODULE_1__components_RegistrationForm__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus'
  }))
});

/***/ }),

/***/ "+tB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPage_vue__ = __webpack_require__("hg+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8566106_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPage_vue__ = __webpack_require__("0aNu");
function injectStyle (ssrContext) {
  __webpack_require__("7upm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8566106"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8566106_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+uyx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/IDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__("TbzR");



var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    isLoggedIn: !!sessionStorage.getItem('token'),
    pending: false,
    loggedInUser: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '',
    authUsername: sessionStorage.getItem('apiUser') ? sessionStorage.getItem('apiUser') : '',
    authPassword: sessionStorage.getItem('apiToken') ? sessionStorage.getItem('apiToken') : ''
  },
  getters: {
    getLoginStatus: function getLoginStatus(state) {
      return state.isLoggedIn;
    },
    getLoggedInUser: function getLoggedInUser(state) {
      return state.loggedInUser;
    },
    getAuthUser: function getAuthUser(state) {
      return state.authUsername;
    },
    getAuthPassword: function getAuthPassword(state) {
      return state.authPassword;
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["a" /* LOGIN */], function (state) {
    state.pending = true;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["b" /* LOGIN_SUCCESS */], function (state) {
    state.isLoggedIn = true;
    state.pending = false;
    state.loggedInUser = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["c" /* LOGOUT */], function (state) {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('apiToken');
    sessionStorage.removeItem('apiUser');
    state.isLoggedIn = false;
    state.loggedInUser = '';
    state.authUsername = '';
    state.authPassword = '';
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["d" /* UPDATE_AUTH_DATA */], function (state, authData) {
    sessionStorage.setItem('apiToken', authData.api_pass);
    sessionStorage.setItem('apiUser', authData.api_user);
    state.authUsername = sessionStorage.getItem('apiUser');
    state.authPassword = sessionStorage.getItem('apiToken');
  }), _mutations),
  actions: {
    login: function login(_ref, currentUser) {
      var commit = _ref.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["a" /* LOGIN */]);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(function () {
          sessionStorage.setItem('token', currentUser);
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["b" /* LOGIN_SUCCESS */]);
          resolve();
        }, 1000);
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["c" /* LOGOUT */]);
    },
    updateAuthData: function updateAuthData(_ref3, authData) {
      var commit = _ref3.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["d" /* UPDATE_AUTH_DATA */], authData);
    }
  }
});

/***/ }),

/***/ "/din":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"projects-detail-page"}},[_c('ParallaxHeader',{attrs:{"headline":_vm.getProjectName,"slogan":_vm.getProjectLocation,"headerHeight":'550',"headerImg":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + _vm.projectDetails[_vm.paraIndex].project.parallax_image}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl6":""}},[_c('v-tabs',{attrs:{"color":"grey lighten-2","left":""}},_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.name,on:{"click":function($event){_vm.showTab(tab.tab)}}},[_vm._v("\n            "+_vm._s(tab.name)+"\n          ")])})),_vm._v(" "),(_vm.tabInfo && _vm.projectDetails.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-card',[_c('v-list',{staticClass:"grey lighten-3 hidden-sm-and-down"},_vm._l((_vm.projectDetails),function(item,itemIndex){return _c('v-list-tile',{key:itemIndex,on:{"click":function($event){_vm.showDetailsTab(itemIndex, item.id)}}},[_c('v-list-tile-action',[(_vm.paraIndex === itemIndex)?_c('v-icon',[_vm._v("star")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-title',{staticStyle:{"text-transform":"uppercase","font-size":"10pt","font-weight":"bold","color":"#676767","margin-left":"-20px"},domProps:{"textContent":_vm._s(item.headline)}})],1)})),_vm._v(" "),_c('v-card-text',{staticClass:"hidden-sm-and-down"},[_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Gross Realisation")]),_c('p',[_vm._v(_vm._s(_vm.projectDetails[0].project.gross_realisation))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Date")]),_c('p',[_vm._v(_vm._s(_vm._f("yearFormat")(_vm.projectDetails[0].project.completed_on)))])])]),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-sm-and-down"},[_c('v-btn',{attrs:{"flat":"","color":"orange","icon":""}},[_c('v-icon',[_vm._v("share")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange","icon":""}},[_c('v-icon',[_vm._v("fa-map-marker")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('div',[_c('p',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.projectDetails[_vm.paraIndex].headline)+" \n                  ")]),_c('div',{staticClass:"hidden-md-and-up"},[_c('v-btn',{attrs:{"flat":"","color":"orange","icon":""}},[_c('v-icon',[_vm._v("share")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange","icon":""}},[_c('v-icon',[_vm._v("fa-map-marker")])],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-icon',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("fa-ellipsis-h")]),_vm._v(" "),_c('v-list',{staticClass:"grey lighten-2"},_vm._l((_vm.projectDetails),function(item,itemIndex){return _c('v-list-tile',{key:itemIndex,on:{"click":function($event){_vm.showDetailsTab(itemIndex, item.id)}}},[_c('v-list-tile-action',[(_vm.paraIndex === itemIndex)?_c('v-icon',[_vm._v("star")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-title',{staticStyle:{"text-transform":"uppercase","font-size":"10pt","font-weight":"bold","color":"#676767"},domProps:{"textContent":_vm._s(item.headline)}})],1)}))],1)],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('hr',{staticClass:"buzz-hr"}),_vm._v(" "),(_vm.paraIndex === 0 && _vm.projectDetails[_vm.paraIndex].project.main_image)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-media',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + _vm.projectDetails[_vm.paraIndex].project.main_image,"height":"35vh"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.projectDetails[_vm.paraIndex].content.split('\n')),function(para,i){return (!_vm.showDetailsGallery)?_c('p',{key:i,staticClass:"content-text"},[_vm._v(_vm._s(para))]):_c('ImageGallery',{attrs:{"thumbnail":_vm.detailsGallery}})}),_vm._v(" "),_c('v-spacer')],2)])],1):_c('ImageGallery',{attrs:{"thumbnail":_vm.gallery}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "03yh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "07iq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignMenuItem_vue__ = __webpack_require__("Lxuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aeadbad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignMenuItem_vue__ = __webpack_require__("yrgc");
function injectStyle (ssrContext) {
  __webpack_require__("YR12")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3aeadbad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aeadbad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Obf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginForm__ = __webpack_require__("gosb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LoginForm: __WEBPACK_IMPORTED_MODULE_0__components_LoginForm__["a" /* default */]
  }
});

/***/ }),

/***/ "0W1d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0aNu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('Jumbotron',{on:{"showVideo":function($event){_vm.isShowVideo=!_vm.isShowVideo},"showGallery":function($event){_vm.isShowGallery=!_vm.isShowGallery}}}),_vm._v(" "),_c('ProjectsCard'),_vm._v(" "),(_vm.isShowGallery)?_c('BuzzGallery',{attrs:{"images":_vm.gallery},on:{"showGallery":function($event){_vm.isShowGallery=!_vm.isShowGallery}}}):_vm._e(),_vm._v(" "),(_vm.isShowVideo)?_c('BuzzTube',{attrs:{"videos":_vm.videos},on:{"showVideo":function($event){_vm.isShowVideo=!_vm.isShowVideo}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Jyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ title: 'Dashboard', icon: 'dashboard', path: '/admin' }, { title: 'About', icon: 'dashboard', path: '/admin/about' }, { title: 'Design', icon: 'dashboard', path: '/admin/design' }, { title: 'Experience', icon: 'dashboard', path: '/admin/experience' }, { title: 'Projects', icon: 'dashboard', path: '/admin/project' }, { title: 'Slider Images', icon: 'dashboard', path: '/admin/slider-images' }, { title: 'Image Gallery', icon: 'dashboard', path: '/admin/image-gallery' }, { title: 'Company Contact', icon: 'dashboard', path: '/admin/company-contact' }, { title: 'Social Links', icon: 'dashboard', path: '/admin/social-links' }, { title: 'Video Gallery', icon: 'dashboard', path: '/admin/video-gallery' }],
      right: null
    };
  }
});

/***/ }),

/***/ "1QYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInputForm_vue__ = __webpack_require__("4zLS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f36e47_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectInputForm_vue__ = __webpack_require__("My2c");
function injectStyle (ssrContext) {
  __webpack_require__("EW7c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71f36e47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f36e47_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1af0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1ns2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuzzGallery_vue__ = __webpack_require__("+hSl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41aec97a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuzzGallery_vue__ = __webpack_require__("v3cX");
function injectStyle (ssrContext) {
  __webpack_require__("VVqg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41aec97a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuzzGallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41aec97a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuzzGallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1qR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Bezzina',
      links: [{
        name: 'Dashboard',
        path: '/admin',
        icon: 'fa fa-home'
      }],
      drawer: null,
      items: [{ title: 'Dashboard', icon: 'dashboard', path: '/admin' }, { title: 'About', icon: 'dashboard', path: '/admin/about' }, { title: 'Design', icon: 'dashboard', path: '/admin/design' }, { title: 'Experience', icon: 'dashboard', path: '/admin/experience' }, { title: 'Projects', icon: 'dashboard', path: '/admin/project' }, { title: 'Slider Images', icon: 'dashboard', path: '/admin/slider-images' }, { title: 'Image Gallery', icon: 'dashboard', path: '/admin/image-gallery' }, { title: 'Company Contact', icon: 'dashboard', path: '/admin/company-contact' }, { title: 'Social Links', icon: 'dashboard', path: '/admin/social-links' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    isLoggedIn: 'adminUser/getLoginStatus'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    logout: 'adminUser/logout'
  }), {
    logoutUser: function logoutUser() {
      var _this = this;

      var path = '/admin/logout';
      var data = {};
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, data).then(function (response) {
        if (response.data.status === 0) {
          _this.$router.push('/admin/login');
          _this.logout();
        } else {
          _this.$swal(response.data.message);
          _this.$router.push('/admin/login');
          _this.logout();
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
        _this.$router.push('/admin/login');
        _this.logout();
      });
    }
  })
});

/***/ }),

/***/ "2GXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceImageGalleryMenuItem_vue__ = __webpack_require__("VE9/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46aacf10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceImageGalleryMenuItem_vue__ = __webpack_require__("P27z");
function injectStyle (ssrContext) {
  __webpack_require__("3OUu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46aacf10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceImageGalleryMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46aacf10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceImageGalleryMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2J6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact-page"}},[_c('ParallaxHeader',{attrs:{"headline":'Contact Us',"slogan":'Get in touch with our support staff'}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":"","xl3":""}},[_c('v-card',[_c('v-container',[_c('h2',{staticClass:"headline"},[_vm._v("We'd Love to hear from you")]),_vm._v(" "),_c('p',{staticClass:"body-1"},[_vm._v("To request more information, please fill out and submit the form below")]),_vm._v(" "),_c('contact-form')],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":"","xl3":""}},[_c('v-card',[_c('v-container',[_c('iframe',{attrs:{"scrolling":"no","marginheight":"0","marginwidth":"0","src":"https://maps.google.com.au/maps?hl=en&ie=UTF8&q=bezzina+group&fb=1&gl=au&hq=bezzina+group&hnear=0x6b12c81235d88f33:0x5017d681632b360,Cronulla+NSW&cid=0,0,735132850336761037&t=m&ll=-34.052108,151.155546&spn=0.006222,0.00912&z=16&iwloc=A&output=embed","width":"100%","height":"450","frameborder":"0"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_c('a',{staticStyle:{"color":"#0000FF","text-align":"left"},attrs:{"href":"https://maps.google.com.au/maps?hl=en&ie=UTF8&q=the+promenade+cronulla&fb=1&gl=au&hq=the+promenade&hnear=0x6b12c81235d88f33:0x5017d681632b360,Cronulla+NSW&cid=0,0,735132850336761037&t=m&ll=-34.052108,151.155546&spn=0.006222,0.00912&z=16&iwloc=A&source=embed"}},[_vm._v("View Larger Map")])])])],1),_vm._v(" "),_vm._l((_vm.aboutData),function(item,index){return (_vm.aboutData.length > 0)?_c('v-card',{key:index},[_c('v-container',[_c('div',{staticStyle:{"text-align":"center"}},[_c('h2',{staticClass:"display-1"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('hr',{staticClass:"buzz-hr"}),_vm._v(" "),(item.address !== '')?_c('p',{staticClass:"content-text"},[_vm._v(_vm._s(item.address))]):_vm._e(),_vm._v(" "),(item.telephone !== '')?_c('p',{staticClass:"content-text"},[_c('v-icon',[_vm._v(_vm._s("fa fa-2x fa-phone"))]),_vm._v(" : "+_vm._s(item.telephone))],1):_vm._e(),_vm._v(" "),(item.fax !== '')?_c('p',{staticClass:"content-text"},[_c('v-icon',[_vm._v(_vm._s("fa fa-2x fa-fax"))]),_vm._v(" : "+_vm._s(item.fax))],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"content-text"},[_c('v-icon',[_vm._v(_vm._s("fa fa-2x fa-envelope"))]),_vm._v(" :  "+_vm._s(item.email))],1)])])],1):_vm._e()})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ccQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ParallaxHeader__ = __webpack_require__("A+Hu");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    About: __WEBPACK_IMPORTED_MODULE_0__components_About__["a" /* default */],
    ParallaxHeader: __WEBPACK_IMPORTED_MODULE_1__components_ParallaxHeader__["a" /* default */]
  }
});

/***/ }),

/***/ "2w19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"image-gallery-page"}},[_c('ParallaxHeader',{attrs:{"headline":'Image Gallery',"slogan":''}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl6":""}},[_c('BuzzGallery',{attrs:{"images":_vm.gallery}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3GzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BuzzGallery__ = __webpack_require__("1ns2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    thumbnail: {
      required: true,
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      page: 1,
      imagesPerPage: 12,
      index: 0,
      isShowGallery: false
    };
  },

  components: {
    BuzzGallery: __WEBPACK_IMPORTED_MODULE_0__components_BuzzGallery__["a" /* default */]
  },
  computed: {
    getImagePerPage: function getImagePerPage() {
      return this.thumbnail.slice((this.page - 1) * this.imagesPerPage, this.imagesPerPage * this.page);
    }
  },
  methods: {
    showImage: function showImage(image) {
      if (this.page === 1) {
        this.index = image;
      } else {
        this.index = this.imagesPerPage * (this.page - 1) + image;
      }
      this.isShowGallery = !this.isShowGallery;
    }
  }
});

/***/ }),

/***/ "3OUu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Yui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashBoardFooter_vue__ = __webpack_require__("3zhd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d2f2569_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashBoardFooter_vue__ = __webpack_require__("XyWt");
function injectStyle (ssrContext) {
  __webpack_require__("1af0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d2f2569"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashBoardFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d2f2569_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashBoardFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3xEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-page"}},[_c('ParallaxHeader',{attrs:{"headline":'About Us',"slogan":''}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('About')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3zhd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CopyrightComponent_vue__ = __webpack_require__("RuZG");
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CopyrightComponent: __WEBPACK_IMPORTED_MODULE_0__CopyrightComponent_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "4+mf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsList_vue__ = __webpack_require__("gmke");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a223c81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsList_vue__ = __webpack_require__("OUFY");
function injectStyle (ssrContext) {
  __webpack_require__("XZBy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a223c81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a223c81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4yKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialLinksInputForm_vue__ = __webpack_require__("Lsjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bfdb436_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialLinksInputForm_vue__ = __webpack_require__("wwrJ");
function injectStyle (ssrContext) {
  __webpack_require__("myhQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bfdb436"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialLinksInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bfdb436_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialLinksInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4zLS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AboutInputForm__ = __webpack_require__("8QNr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['buttonName', 'editData', 'projectId'],
  data: function data() {
    return {
      valid: true,
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }],
      description: '',
      descriptionRules: [function (v) {
        return !!v || 'Description is required';
      }],
      location: '',
      locationRules: [function (v) {
        return !!v || 'Location is required';
      }],
      grossRealisation: '',
      grossRealisationRules: [function (v) {
        return !!v || 'Gross Realisation is required';
      }],
      imageFile: '',
      parallaxImageFile: '',
      completedOn: '',
      editDetailsData: null,
      projectDetailsData: [],
      detailsButtonName: 'Add',
      showProjectDetailsForm: false,
      menu2: false,
      headers: [{
        text: 'Title',
        align: 'left',
        sortable: false,
        value: 'detailTitle'
      }, { text: 'Content', align: 'right', value: 'content' }, { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' }, { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' }, { text: 'Edit', sortable: false, align: 'right', value: 'edit' }]
    };
  },

  components: {
    ProjectDetailsForm: __WEBPACK_IMPORTED_MODULE_3__components_AboutInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (this.editData) {
      this.name = this.editData.name;
      this.description = this.editData.short_description;
      this.location = this.editData.location;
      this.grossRealisation = this.editData.gross_realisation;
      var value = this.editData.completed_on;
      this.completedOn = __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).year() + '-' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).month() + '-' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).date();
      this.imageFile = 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + this.editData.main_image;
      this.parallaxImageFile = 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + this.editData.parallax_image;
      this.projectDetailsData = this.editData.projectDetails;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  }), {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.completedOn);
    }
  }),
  methods: {
    submit: function submit() {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          var data = {
            name: this.name,
            description: this.description,
            location: this.location,
            gross_realisation: this.grossRealisation,
            completed_on: this.completedOn,
            current_user: this.currentUser,
            project_details: this.projectDetailsData
          };
          var imageInput = this.$el.querySelector('#file');
          var parallaxImageInput = this.$el.querySelector('#parallaxfile');
          this.$emit('addItem', data, imageInput, parallaxImageInput);
        }
      } else {
        if (this.$refs.form.validate()) {
          var _data = {
            name: this.name,
            description: this.description,
            location: this.location,
            gross_realisation: this.grossRealisation,
            completed_on: this.completedOn,
            current_user: this.currentUser,
            project_details: this.projectDetailsData
          };
          var _imageInput = this.$el.querySelector('#file');
          var _parallaxImageInput = this.$el.querySelector('#parallaxfile');
          this.$emit('updateItem', this.editData.id, _data, _imageInput, _parallaxImageInput);
        }
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    },
    onFileChange: function onFileChange(e, type) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0], type);
    },
    createImage: function createImage(file, type) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        if (type === 'main') {
          vm.imageFile = e.target.result;
        } else if (type === 'parallax') {
          vm.parallaxImageFile = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    removeImage: function removeImage(e) {
      if (e === 'main') {
        var imageInput = this.$el.querySelector('#file');
        imageInput.value = '';
        this.imageFile = '';
      } else if (e === 'parallax') {
        var _imageInput2 = this.$el.querySelector('#parallaxfile');
        _imageInput2.value = '';
        this.parallaxImageFile = '';
      }
    },
    showAddForm: function showAddForm() {
      this.showProjectDetailsForm = true;
      this.editDetailsData = null;
    },
    showNewDetailsItem: function showNewDetailsItem(data, imageFile) {
      this.showProjectDetailsForm = false;
      data.headline = data.title;
      data.author = { 'email': '' };
      data.modified_on = '';
      this.projectDetailsData.push(data);
    },
    showEditForm: function showEditForm(item) {
      this.showProjectDetailsForm = true;
      this.editDetailsData = item;
    },
    showUpdatedDetailsItem: function showUpdatedDetailsItem(detailsId, data, imageFile) {
      var _this = this;

      this.showProjectDetailsForm = false;
      data.headline = data.title;
      data.author = { 'email': '' };
      data.modified_on = '';
      this.projectDetailsData.forEach(function (el) {
        if (el.id === detailsId) {
          _this.projectDetailsData[_this.projectDetailsData.indexOf(el)] = data;
        }
      });
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      this.projectDetailsData.pop(item);
      var path = '/project/' + this.editData.id + '/' + item.id;
      // console.log(path)
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this2.$swal(response.data.message);
          _this2.$emit('detailsDeleted');
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    }
  }
});

/***/ }),

/***/ "50zn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Iuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['buttonName', 'editData', 'formTitle'],
  data: function data() {
    return {
      projectSelected: null,
      projectDetailsSelected: null,
      id: null,
      valid: true,
      imageFile: '',
      projectItems: [],
      projectDetailsItems: []
    };
  },
  beforeMount: function beforeMount() {
    this.getProjectsData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  })),
  watch: {
    projectSelected: function projectSelected() {
      this.projectDetailsItems = [];
      if (this.projectSelected !== null) {
        this.getProjectDetails(this.projectSelected.id);
      }
    }
  },
  methods: {
    getProjectsData: function getProjectsData() {
      var _this = this;

      var path = '/project';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // this.projects = response.data.project
          response.data.project.forEach(function (el) {
            _this.projectItems.push({ text: el.name, id: el.id });
          });
          // this.projectDetails = response.data.project_details
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    getProjectDetails: function getProjectDetails(projectID) {
      var _this2 = this;

      var path = '/project/' + projectID;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          response.data.project_details.forEach(function (el) {
            _this2.projectDetailsItems.push({ text: el.headline, id: el.id });
          });
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    },
    submit: function submit() {
      if (this.$refs.form.validate()) {
        var data = {
          id: this.id,
          project_id: this.projectSelected.id,
          project_details_id: this.projectDetailsSelected.id,
          current_user: this.currentUser
        };
        var imageInput = this.$el.querySelector('#file');
        this.$emit('addItem', data, imageInput);
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.imageFile = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function removeImage(e) {
      var imageInput = this.$el.querySelector('#file');
      imageInput.value = '';
      this.imageFile = '';
    }
  }
});

/***/ }),

/***/ "5zRc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsPage_vue__ = __webpack_require__("9NT6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ae1e8e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsPage_vue__ = __webpack_require__("oVeU");
function injectStyle (ssrContext) {
  __webpack_require__("j+yj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ae1e8e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ae1e8e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "74qs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    details: {
      required: true,
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "7JSO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SzN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7ewF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialLinksMenuItem_vue__ = __webpack_require__("DFWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ca2256_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialLinksMenuItem_vue__ = __webpack_require__("PknD");
function injectStyle (ssrContext) {
  __webpack_require__("UPH+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30ca2256"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialLinksMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ca2256_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialLinksMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7upm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "86aM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationForm_vue__ = __webpack_require__("LMHU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_074f5b19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationForm_vue__ = __webpack_require__("nUEY");
function injectStyle (ssrContext) {
  __webpack_require__("yQ7t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-074f5b19"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_074f5b19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8QNr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutInputForm_vue__ = __webpack_require__("lmbe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb6f919_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutInputForm_vue__ = __webpack_require__("on22");
function injectStyle (ssrContext) {
  __webpack_require__("9aS7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fb6f919"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb6f919_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8riQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ParallaxHeader__ = __webpack_require__("A+Hu");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    About: __WEBPACK_IMPORTED_MODULE_0__components_About__["a" /* default */],
    ParallaxHeader: __WEBPACK_IMPORTED_MODULE_1__components_ParallaxHeader__["a" /* default */]
  }
});

/***/ }),

/***/ "8wF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 col-lg-12 col-sm-5 col-xs-5",attrs:{"id":"copyright"}},[_c('p',[_vm._v("Copyright © Bezzina "+_vm._s(_vm.current_year))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9NT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProjectsList__ = __webpack_require__("4+mf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CompletedDevelopment__ = __webpack_require__("QAKA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ParallaxHeader__ = __webpack_require__("A+Hu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tabAll: true,
      tabCompleted: false,
      tabs: [{ name: 'All', tab: 'tab-all'
        // {name: 'Completed Developments', tab: 'tab-completed'}
      }],
      projects: []
      // projectDetails: []
    };
  },

  components: {
    Projects: __WEBPACK_IMPORTED_MODULE_0__components_ProjectsList__["a" /* default */],
    CompletedDevelopments: __WEBPACK_IMPORTED_MODULE_1__components_CompletedDevelopment__["a" /* default */],
    ParallaxHeader: __WEBPACK_IMPORTED_MODULE_2__components_ParallaxHeader__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.getProjectsData();
  },

  methods: {
    showTab: function showTab(tabName) {
      if (tabName === 'tab-all') {
        this.tabAll = true;
        this.tabCompleted = false;
      } else if (tabName === 'tab-completed') {
        this.tabAll = false;
        this.tabCompleted = true;
      }
    },
    getProjectsData: function getProjectsData() {
      var _this = this;

      var path = '/project';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.projects = response.data.project;
          // this.projectDetails = response.data.project_details
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "9aS7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9vnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleImageInputForm_vue__ = __webpack_require__("5Iuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca6d4508_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleImageInputForm_vue__ = __webpack_require__("HbfS");
function injectStyle (ssrContext) {
  __webpack_require__("+4/C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca6d4508"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleImageInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca6d4508_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleImageInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A+Hu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParallaxHeader_vue__ = __webpack_require__("kIk4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfc99724_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParallaxHeader_vue__ = __webpack_require__("HRsS");
function injectStyle (ssrContext) {
  __webpack_require__("NahR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cfc99724"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParallaxHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfc99724_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParallaxHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ACdr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageGalleryMenuItem_vue__ = __webpack_require__("yctl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4f3c4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageGalleryMenuItem_vue__ = __webpack_require__("r9pz");
function injectStyle (ssrContext) {
  __webpack_require__("XHoX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b4f3c4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageGalleryMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4f3c4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageGalleryMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ASvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[(_vm.aboutData.length > 0)?_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"xs12":"","md6":"","lg4":"","xl3":""}},[_c('v-card',[_c('v-card-media',[_c('img',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + _vm.aboutData[0].image}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":"","xl3":""}},_vm._l((_vm.aboutData),function(item,index){return _c('div',{key:index,staticClass:"about-div"},[_c('h2',{staticClass:"display-2"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('hr',{staticClass:"buzz-hr"}),_vm._v(" "),_vm._l((item.content.split('\n')),function(para,i){return _c('p',{key:i,staticClass:"content-text"},[_vm._v(_vm._s(para))])})],2)}))],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AWFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['buttonName', 'editData', 'formTitle'],
  data: function data() {
    return {
      id: null,
      valid: true,
      imageFile: ''
    };
  },
  beforeMount: function beforeMount() {
    if (this.editData) {
      this.id = this.editData.id;
      this.imageFile = this.editData.name;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  })),
  methods: {
    submit: function submit() {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          var data = {
            id: this.id,
            current_user: this.currentUser
          };
          var imageInput = this.$el.querySelector('#file');
          this.$emit('addItem', data, imageInput);
        }
      } else {
        if (this.$refs.form.validate()) {
          var _data = {
            id: this.id,
            current_user: this.currentUser
          };
          var _imageInput = this.$el.querySelector('#file');
          this.$emit('updateItem', this.editData.id, _data, _imageInput);
        }
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.imageFile = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function removeImage(e) {
      var imageInput = this.$el.querySelector('#file');
      imageInput.value = '';
      this.imageFile = '';
    }
  }
});

/***/ }),

/***/ "B83S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"registration-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":"","lg5":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('h2',{staticClass:"headline"},[_vm._v("Register")]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Please fill out and submit the form below")]),_vm._v(" "),_c('RegistrationForm')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BTQO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'copyright',
  data: function data() {
    return {
      current_year: ''
    };
  },

  methods: {
    getCurrentYear: function getCurrentYear() {
      var currentDate = new Date();
      this.current_year = currentDate.getFullYear();
    }
  },
  created: function created() {
    this.getCurrentYear();
  }
});

/***/ }),

/***/ "BbHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"experience-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Experience")]),_vm._v(" "),(!_vm.showExperienceForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.experienceData.length > 0 && !_vm.showExperienceForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.experienceData,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.content.substring(0, 100)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('img',{staticStyle:{"max-width":"100px","max-height":"100px"},attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + props.item.image}})]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("dateTimeFormat")(props.item.modified_on)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.author.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"fa primary small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"},on:{"click":function($event){_vm.showEditForm(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"fa dark small mx-3 white--text",attrs:{"icon":"","color":"grey lighten-1"},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("highlight_off")])],1)],1)]}}])})],1):_vm._e(),_vm._v(" "),(_vm.showExperienceForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('ExperienceInputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"goBack":function($event){_vm.showExperienceForm = !_vm.showExperienceForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bpe0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperiencePage_vue__ = __webpack_require__("V/Gv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93d3298c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperiencePage_vue__ = __webpack_require__("yft2");
function injectStyle (ssrContext) {
  __webpack_require__("tZkX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93d3298c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperiencePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93d3298c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperiencePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CZ7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Design_vue__ = __webpack_require__("74qs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_285d2e6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Design_vue__ = __webpack_require__("hTE1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Design_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_285d2e6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Design_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ckuf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    videos: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      activeVideo: this.activeIndex,
      videosPerPage: 5,
      page: 1
    };
  },

  computed: {
    getVideosPerPage: function getVideosPerPage() {
      return this.videos.slice((this.page - 1) * this.videosPerPage, this.videosPerPage * this.page);
    }
  },
  methods: {
    showVideo: function showVideo(index) {
      if (this.page === 1) {
        this.activeVideo = index;
      } else {
        this.activeVideo = this.videosPerPage * (this.page - 1) + index;
      }
    },
    showOpacity: function showOpacity(index) {
      if (this.page === 1) {
        if (this.activeVideo === index) {
          return true;
        }
        return false;
      } else {
        if (this.activeVideo === this.videosPerPage * (this.page - 1) + index) {
          return true;
        }
        return false;
      }
    },
    handleKeyUp: function handleKeyUp(e) {
      if (e.key === 'ArrowRight') {
        this.handleRightClick();
      } else if (e.key === 'ArrowLeft') {
        this.handleLeftClick();
      }
      // const activeDiv = this.$el.querySelector('#' + this.activeVideo)
    },
    handleRightClick: function handleRightClick() {
      if (this.activeVideo === this.videos.length - 1) {
        this.page = 1;
        this.activeVideo = 0;
      } else if (this.activeVideo === this.videosPerPage * this.page - 1) {
        this.activeVideo += 1;
        this.page += 1;
      } else {
        this.activeVideo += 1;
      }
    },
    handleLeftClick: function handleLeftClick() {
      if (this.activeVideo === 0) {
        this.activeVideo = this.videos.length - 1;
        this.page = Math.round(this.videos.length / this.videosPerPage);
      } else if (this.activeVideo === (this.page - 1) * this.videosPerPage) {
        this.activeVideo -= 1;
        this.page -= 1;
      } else {
        this.activeVideo -= 1;
      }
    },
    handleBlurEvent: function handleBlurEvent() {
      var inputBox = this.$el.querySelector('#hidden-input');
      setTimeout(function () {
        inputBox.focus();
      }, 10);
    },
    pageUp: function pageUp() {
      if (this.page === Math.ceil(this.videos.length / this.videosPerPage)) {
        this.page = 1;
        this.activeVideo = 0;
      } else {
        this.activeVideo = this.page * this.videosPerPage;
        this.page += 1;
      }
    },
    pageDown: function pageDown() {
      if (this.page !== 1) {
        this.page -= 1;
        this.activeVideo = this.page * this.videosPerPage - this.videosPerPage;
      } else {
        this.page = Math.ceil(this.videos.length / this.videosPerPage);
        this.activeVideo = this.page * this.videosPerPage - this.videosPerPage;
      }
    }
  }
});

/***/ }),

/***/ "Cp9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"input-form"}},[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.nameRules,"label":"Name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.addressRules,"label":"Address","required":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.propertyRules,"label":"Property","required":""},model:{value:(_vm.property),callback:function ($$v) {_vm.property=$$v},expression:"property"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Completed On","hint":"DD/MM/YYYY","persistent-hint":"","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.computedDateFormatted),callback:function ($$v) {_vm.computedDateFormatted=$$v},expression:"computedDateFormatted"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.completedOn),callback:function ($$v) {_vm.completedOn=$$v},expression:"completedOn"}})],1),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cq4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"not-found-page"}},[_c('ParallaxHeader',{attrs:{"headline":'Page Not Found',"slogan":''}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_vm._v("\n      Requested Page not Found\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cxol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationPage_vue__ = __webpack_require__("+so8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b30c5462_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationPage_vue__ = __webpack_require__("B83S");
function injectStyle (ssrContext) {
  __webpack_require__("yL51")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b30c5462"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b30c5462_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D5ED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMenuItem_vue__ = __webpack_require__("qTRK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589203d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMenuItem_vue__ = __webpack_require__("I0y0");
function injectStyle (ssrContext) {
  __webpack_require__("Nw6D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-589203d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589203d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DFWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SocialLinksInputForm__ = __webpack_require__("4yKh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: [],
      showAboutForm: false,
      editData: null,
      buttonName: 'Add',
      headers: [{
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'name'
      }, { text: 'Icon', align: 'right', value: 'icon' }, { text: 'Link', align: 'right', value: 'link' }, { text: 'Show Icon', align: 'right', value: 'show' }, { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' }, { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' }, { text: 'Edit', sortable: false, align: 'right', value: 'edit' }]
    };
  },

  components: {
    SocialLinksInputForm: __WEBPACK_IMPORTED_MODULE_4__components_SocialLinksInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getAboutData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getAboutData: function getAboutData() {
      var _this = this;

      var path = '/social-links';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          console.log(response.data.sociallinks);
          _this.aboutData = response.data.sociallinks;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Add';
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Update';
      this.editData = item;
    },
    addItem: function addItem(data) {
      var _this2 = this;

      var path = '/social-links';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      // formData.append('image', imageFile.files[0])
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this2.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this2.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth).then(function (response) {
              if (response.data.status === 0) {
                _this2.$swal(response.data.message);
                _this2.showAboutForm = !_this2.showAboutForm;
                _this2.getAboutData();
              } else {
                _this2.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this2.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this2.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data) {
      var _this3 = this;

      var path = '/social-links/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      // formData.append('image', imageFile.files[0])
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this3.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth).then(function (response) {
            if (response.data.status === 0) {
              _this3.$swal(response.data.message);
              _this3.showAboutForm = !_this3.showAboutForm;
              _this3.getAboutData();
            } else {
              _this3.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this3.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item, index) {
      var _this4 = this;

      var path = '/social-links/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this4.getAboutData();
          _this4.$swal(response.data.message);
        } else {
          _this4.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this4.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "DKRO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E4v1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageGalleryPage_vue__ = __webpack_require__("P02B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ef7ea2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageGalleryPage_vue__ = __webpack_require__("2w19");
function injectStyle (ssrContext) {
  __webpack_require__("WwMi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54ef7ea2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageGalleryPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ef7ea2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageGalleryPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EKYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // cards: [
      //   // { title: 'Sienna', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/sienna-header.jpg', flex: 12 },
      //   { title: 'Jade', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/background4.jpg', flex: 3 },
      //   { title: 'Sienna', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/background5.jpg', flex: 3 },
      //   { title: 'Mia', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/background6.jpg', flex: 3 },
      //   { title: 'Tiana', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/background1.jpg', flex: 3 }
      // ]
      cardFlex: 3,
      projects: [],
      projectDetails: []
    };
  },
  beforeMount: function beforeMount() {
    this.getProjectsData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    updateActiveProjectID: 'projects/updateActiveProjectID',
    updateActiveProjectName: 'projects/updateActiveProjectName',
    updateActiveProjectDetails: 'projects/updateActiveProjectDetails',
    updateActiveProjectLocation: 'projects/updateActiveProjectLocation'
  }), {
    showProject: function showProject(card) {
      this.getProjectDetails(card);
    },
    getProjectsData: function getProjectsData() {
      var _this = this;

      var path = '/project/frontpage';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.projects = response.data.project;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    getProjectDetails: function getProjectDetails(project) {
      var _this2 = this;

      var path = '/project/' + project.id;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this2.updateActiveProjectDetails(response.data.project_details);
          _this2.updateActiveProjectName(project.name);
          _this2.updateActiveProjectLocation(project.location);
          _this2.updateActiveProjectID(project.id);
          _this2.$router.push('/works/' + project.name);
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    }
  })
});

/***/ }),

/***/ "ENl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyContactInputForm_vue__ = __webpack_require__("ZH30");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028e6cee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyContactInputForm_vue__ = __webpack_require__("Hxye");
function injectStyle (ssrContext) {
  __webpack_require__("Pyrw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-028e6cee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyContactInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028e6cee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyContactInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EW7c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ez/3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SliderImagesMenuItem_vue__ = __webpack_require__("kTPe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d9aa64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SliderImagesMenuItem_vue__ = __webpack_require__("skJ8");
function injectStyle (ssrContext) {
  __webpack_require__("zQ5M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02d9aa64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SliderImagesMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d9aa64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SliderImagesMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FDXK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"admin-homepage"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":"","lg5":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/project-image-gallery')}}},[_vm._v("Projects Image Gallery")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/experience-image-gallery')}}},[_vm._v("Experience Image Gallery")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FleL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-div",on:{"click":_vm.hideVideo}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"width":"75%","controls":"","autoplay":"","loop":""}},[_c('source',{attrs:{"src":"https://cdnblobendpoint.azureedge.net/bezzina-static/video/frontpage-demo-video.mp4","type":"video/mp4"}}),_vm._v("\n    HTML5 video not supported by this browser\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G366":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HRsS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"src":_vm.headerImg,"height":_vm.headerHeight}},[_c('div',{staticClass:"left-bottom-gradient"}),_vm._v(" "),_c('v-layout',{staticStyle:{"position":"relative","z-index":"1"},attrs:{"align-end":""}},[_c('v-flex',[_c('h3',{staticClass:"display-3",attrs:{"id":"page-name"}},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"headline",attrs:{"id":"slogan"}},[_vm._v(_vm._s(_vm.slogan))])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HVta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md2":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Video Gallery")]),_vm._v(" "),(!_vm.showAboutForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.aboutData),function(item,index){return (_vm.aboutData.length > 0 && !_vm.showAboutForm)?_c('v-flex',{key:index,attrs:{"xs2":"","offset-md2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('img',{staticStyle:{"max-width":"250px","max-height":"250px"},attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.thumbnail}}),_vm._v(" "),(!item.is_youtube_link)?_c('video',{staticStyle:{"max-width":"250px","max-height":"200px"},attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/video/' + item.video,"controls":""}}):_c('iframe',{attrs:{"width":"250","height":"200","src":item.youtube_link,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}}),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified on: "+_vm._s(_vm._f("dateTimeFormat")(item.modified_on)))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified by: "+_vm._s(item.author.email))]),_vm._v(" "),_c('v-btn',{staticClass:"fa primary small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"},on:{"click":function($event){_vm.showEditForm(item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"dark small mx-3 white--text",attrs:{"color":"black","round":""},on:{"click":function($event){_vm.deleteItem(item)}}},[_c('v-icon',[_vm._v("highlight_off")]),_vm._v(" Remove\n            ")],1)],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md2":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('InputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"goBack":function($event){_vm.showAboutForm = !_vm.showAboutForm}}})],1)],1)],1):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HbfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-form"}},[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-select',{attrs:{"items":_vm.projectItems,"label":"Select Project","single-line":""},model:{value:(_vm.projectSelected),callback:function ($$v) {_vm.projectSelected=$$v},expression:"projectSelected"}}),_vm._v(" "),(_vm.projectSelected)?_c('v-select',{attrs:{"items":_vm.projectDetailsItems,"label":"Select Project Detail","single-line":""},model:{value:(_vm.projectDetailsSelected),callback:function ($$v) {_vm.projectDetailsSelected=$$v},expression:"projectDetailsSelected"}}):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"file","name":"file","multiple":""},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.imageFile)?_c('div',[_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.imageFile}}),_vm._v(" "),_c('v-icon',{on:{"click":_vm.removeImage}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HnH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"design-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Completed Developments")]),_vm._v(" "),(!_vm.showDesignForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},on:{"click":_vm.showAddForm}},[_vm._v("+ Add Item")]):_vm._e()],1),_vm._v(" "),(_vm.designData.length > 0 && !_vm.showDesignForm)?_c('v-flex',{attrs:{"xs12":"","offset-md2":""}},_vm._l((_vm.designData),function(item,index){return _c('v-card',{key:index,attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('p',{staticClass:"headline"},[_vm._v("Title")]),_vm._v(" "),_c('p',{staticClass:"content-text"},[_vm._v(_vm._s(item.name))]),_c('p',{staticClass:"headline"},[_vm._v("Address")]),_vm._v(" "),_c('p',{staticClass:"content-text"},[_vm._v(_vm._s(item.address))]),_vm._v(" "),_c('p',{staticClass:"headline"},[_vm._v("Property")]),_vm._v(" "),_c('p',{staticClass:"content-text"},[_vm._v(_vm._s(item.properties))]),_vm._v(" "),_c('p',{staticClass:"headline"},[_vm._v("Completed on")]),_vm._v(" "),_c('p',{staticClass:"content-text"},[_vm._v(_vm._s(item.completed))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified on: "+_vm._s(_vm._f("datetimeFormat")(item.modified_on)))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified by: "+_vm._s(item.author.email))]),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.showEditForm(item)}}},[_vm._v("Edit Item")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.deleteItem(item, index)}}},[_vm._v("Remove Item")])],1)],1)})):_vm._e(),_vm._v(" "),(_vm.showDesignForm)?_c('v-flex',{attrs:{"xs12":"","offset-md2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('CompletedDevInputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"goBack":function($event){_vm.showDesignForm = !_vm.showDesignForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hxye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"company-contact-form"}},[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.titleRules,"label":"Title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Address"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Telephone"},model:{value:(_vm.telephone),callback:function ($$v) {_vm.telephone=$$v},expression:"telephone"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Fax"},model:{value:(_vm.fax),callback:function ($$v) {_vm.fax=$$v},expression:"fax"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.emailRules,"label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I0y0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("About")]),_vm._v(" "),(!_vm.showAboutForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.aboutData.length > 0 && !_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},_vm._l((_vm.aboutData),function(item,index){return _c('v-card',{key:index,attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('p',{staticClass:"headline"},[_vm._v("Title")]),_vm._v(" "),_c('p',{staticClass:"content-text"},[_vm._v(_vm._s(item.title))]),_c('p',{staticClass:"headline"},[_vm._v("Content")]),_vm._v(" "),_c('p',{staticClass:"content-text"},[_vm._v(_vm._s(item.content))]),_vm._v(" "),_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.image}}),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified on: "+_vm._s(_vm._f("dateTimeFormat")(item.modified_on)))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified by: "+_vm._s(item.author.email))]),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.showEditForm(item)}}},[_vm._v("Edit Item")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.deleteItem(item, index)}}},[_vm._v("Remove Item")])],1)],1)})):_vm._e(),_vm._v(" "),(_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('AboutInputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"goBack":function($event){_vm.showAboutForm = !_vm.showAboutForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ILp5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.projects.slice(0, 8).reverse()),function(card){return _c('v-flex',_vm._b({key:card.title,on:{"click":function($event){_vm.showProject(card)}}},'v-flex',( _obj = {}, _obj[("xs" + (_vm.cardFlex * 2))] = true, _obj[("sm" + _vm.cardFlex)] = true, _obj ),false),[_c('v-card',{attrs:{"hover":"","raised":"","height":"49vh"}},[_c('v-card-media',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + card.main_image,"height":"50vh"}},[_c('div',{staticClass:"left-top-gradient"}),_vm._v(" "),_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline white--text card-title",staticStyle:{"position":"relative"},domProps:{"textContent":_vm._s(card.name)}})])],1)],1)],1)],1)],1)
var _obj;}))],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_projects_store_js__ = __webpack_require__("bS7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_design_store_js__ = __webpack_require__("ZlrH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_admin_user_store_js__ = __webpack_require__("/IDX");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    projects: __WEBPACK_IMPORTED_MODULE_2__modules_projects_store_js__["a" /* default */],
    designs: __WEBPACK_IMPORTED_MODULE_3__modules_design_store_js__["a" /* default */],
    adminUser: __WEBPACK_IMPORTED_MODULE_4__modules_admin_user_store_js__["a" /* default */]
  }
}));

/***/ }),

/***/ "IdEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    }
  },

  watch: {
    loginStatus: function loginStatus() {
      if (!this.loginStatus) {
        this.$router.push('/admin/login');
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    logout: 'adminUser/logout'
  }))
});

/***/ }),

/***/ "IifK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashBoardNavDrawer_vue__ = __webpack_require__("1Jyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88323302_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashBoardNavDrawer_vue__ = __webpack_require__("zqzV");
function injectStyle (ssrContext) {
  __webpack_require__("qV5V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88323302"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashBoardNavDrawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88323302_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashBoardNavDrawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IlA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.getImagePerPage),function(item,i){return _c('v-flex',_vm._b({key:i,on:{"click":function($event){_vm.showImage(i)}}},'v-flex',( _obj = {}, _obj[("xs" + (3 * 2))] = true, _obj[("sm" + (3))] = true, _obj[("md" + (3))] = true, _obj[("lg" + (3))] = true, _obj ),false),[_c('v-card',{attrs:{"hover":"","raised":"","height":"120"}},[_c('v-card-media',{attrs:{"src":item.image,"height":"120"}})],1)],1)
var _obj;}),_vm._v(" "),(_vm.isShowGallery)?_c('BuzzGallery',{attrs:{"images":_vm.thumbnail,"activeIndex":_vm.index},on:{"showGallery":function($event){_vm.isShowGallery=!_vm.isShowGallery}}}):_vm._e()],2)],1),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-pagination',{attrs:{"length":Math.ceil(_vm.thumbnail.length/_vm.imagesPerPage),"circle":""},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jv72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayer_vue__ = __webpack_require__("Mbx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673e2544_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayer_vue__ = __webpack_require__("FleL");
function injectStyle (ssrContext) {
  __webpack_require__("Q49J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-673e2544"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673e2544_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K07q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Bezzina',
      links: [{
        name: 'Experience',
        items: ['Company Profile', 'Events', 'News', 'Office', 'Aviation', 'Interviews', 'Videos', 'Contact us'],
        path: '/experience',
        icon: 'fa fa-trophy'
      }, {
        name: 'Works',
        items: ['Point Piper SIENNA', 'Surfers Paradise JADE', 'Burraneer Bay TARA', 'Elouera Beach MIA', 'Cronulla Beach TIANA', 'Stanmore THE METERHOUSE', 'Turramura Retirement Village THE LANDINGS', 'Redferen THE FOUNDRY', 'Balmain DOCKSIDE', 'Redfern SIGNATURES', 'Taloombi street residence'],
        path: '/works',
        icon: 'fa fa-building'
      }, {
        name: 'Design',
        items: ['Interior', 'Landscape', 'Materials', 'Lifestyle'],
        path: '/design',
        icon: 'fa fa-diamond'
      }, {
        name: 'Contact',
        items: [],
        path: '/contact',
        icon: 'fa fa-address-book'
      }, {
        name: 'About',
        items: [],
        path: '/about',
        icon: 'fa fa-question-circle'
      }],
      drawer: null
      // navitems: [
      //   {text: 'Experience', navlink: '#experience'},
      //   {text: 'Works', navlink: '#works'},
      //   {text: 'Design', navlink: '#design'}
      // ]
      // dropdownitems: [
      //   {text: 'Corporate', dropdownitems: [{text: 'History', navlink: '#history'}, {text: 'Awards', navlink: '#awards'}, {text: 'Sponsorship', navlink: '#sponsorship'}]},
      //   {text: 'Style', dropdownitems: [{text: 'Design', navlink: '#design'}, {text: 'Interiors', navlink: '#interiors'}, {text: 'Landscaping', navlink: '#landscaping'}]}
      // ]
    };
  },

  methods: {
    showComponent: function showComponent(component) {
      this.$emit('changeComponent', component);
      setTimeout(function () {
        window.location.hash = '#' + component.toLowerCase().replace(/\s/g, '');
      }, 100);
    }
  }
});

/***/ }),

/***/ "K55/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"psr-navbar"},[_c('v-toolbar',{staticClass:"grey darken-4",attrs:{"dark":"","dense":"","fixed":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('img',{staticStyle:{"width":"150px","height":"40px","margin-left":"1vw"},attrs:{"src":"https://cdnblobendpoint.azureedge.net/bezzina-static/img/bezzina-logo.png","alt":"Bezzina"},on:{"click":function($event){_vm.$router.push('/')}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},_vm._l((_vm.links),function(link,index){return _c('v-btn',{key:index,style:({color : _vm.$route.path.indexOf(link.name.toLowerCase()) !== -1 ? 'orange' : 'white'}),attrs:{"slot":"activator","flat":""},on:{"click":function($event){_vm.$router.push(link.path)}},slot:"activator"},[_vm._v("\n        "+_vm._s(link.name)+"\n      ")])}))],1),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"hidden-md-and-up",attrs:{"temporary":"","fixed":"","floating":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"title",on:{"click":function($event){_vm.$router.push('/')}}},[_c('v-icon',[_vm._v(_vm._s("fa fa-home"))]),_c('span',{staticStyle:{"padding-left":"30px"}},[_vm._v("Home")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticClass:"hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}},[_vm._v("highlight_off")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.links),function(link,index){return _c('v-list-tile',{key:index},[_c('v-list-tile-action',{on:{"click":function($event){_vm.$router.push(link.path)}}},[_c('v-icon',[_vm._v(_vm._s(link.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{on:{"click":function($event){_vm.$router.push(link.path)}}},[_vm._v(_vm._s(link.name))])],1)],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KEw5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoGalleryInputForm_vue__ = __webpack_require__("LLnX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c81f33c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoGalleryInputForm_vue__ = __webpack_require__("spE9");
function injectStyle (ssrContext) {
  __webpack_require__("KQXN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c81f33c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoGalleryInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c81f33c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoGalleryInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KQXN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KfQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyContactMenuItem_vue__ = __webpack_require__("PtFA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef2aa7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyContactMenuItem_vue__ = __webpack_require__("LHZy");
function injectStyle (ssrContext) {
  __webpack_require__("Sf33")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ef2aa7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyContactMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef2aa7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyContactMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KqOE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsMenuItem_vue__ = __webpack_require__("Oxs9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a18a858_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsMenuItem_vue__ = __webpack_require__("rhlj");
function injectStyle (ssrContext) {
  __webpack_require__("a6Zp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a18a858"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a18a858_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LHZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Company Contact")]),_vm._v(" "),(!_vm.showAboutForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.aboutData.length > 0 && !_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","md9":"","offset-md3":"","offset-lg2":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.aboutData,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.address))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.telephone))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.fax))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("dateTimeFormat")(props.item.modified_on)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.author.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"fa primary small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"},on:{"click":function($event){_vm.showEditForm(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"fa dark small mx-3 white--text",attrs:{"icon":"","color":"grey lighten-1"},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("highlight_off")])],1)],1)]}}])})],1):_vm._e(),_vm._v(" "),(_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('ContactInputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"goBack":function($event){_vm.showAboutForm = !_vm.showAboutForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LLnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['buttonName', 'editData', 'formTitle'],
  data: function data() {
    return {
      id: null,
      valid: true,
      name: '',
      imageFile: '',
      videoFile: '',
      isYoutubeLink: false,
      youtubeLink: ''
    };
  },
  beforeMount: function beforeMount() {
    if (this.editData) {
      this.id = this.editData.id;
      this.name = this.editData.name;
      this.imageFile = this.editData.thumbnail;
      this.videoFile = this.editData.video;
      this.isYoutubeLink = this.editData.is_youtube_link;
      this.youtubeLink = this.editData.youtube_link;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  })),
  methods: {
    submit: function submit() {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          var data = {
            id: this.id,
            name: this.name,
            is_youtube_link: this.isYoutubeLink,
            youtube_link: this.youtubeLink,
            current_user: this.currentUser
          };
          var imageInput = this.$el.querySelector('#file');
          var videoInput = this.$el.querySelector('#videofile');
          this.$emit('addItem', data, imageInput, videoInput);
        }
      } else {
        if (this.$refs.form.validate()) {
          var _data = {
            id: this.id,
            name: this.name,
            is_youtube_link: this.isYoutubeLink,
            youtube_link: this.youtubeLink,
            current_user: this.currentUser
          };
          var _imageInput = this.$el.querySelector('#file');
          var _videoInput = this.$el.querySelector('#videofile');
          this.$emit('updateItem', this.editData.id, _data, _imageInput, _videoInput);
        }
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.imageFile = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function removeImage(e) {
      var imageInput = this.$el.querySelector('#file');
      imageInput.value = '';
      this.imageFile = '';
    },
    removeVideo: function removeVideo(e) {
      var videoInput = this.$el.querySelector('#videofile');
      videoInput.value = '';
      this.videoFile = '';
      this.isYoutubeLink = false;
      this.youtubeLink = '';
    }
  }
});

/***/ }),

/***/ "LMHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-form',
  data: function data() {
    var _this = this;

    return {
      e1: true,
      e2: true,
      valid: true,
      username: '',
      nameRules: [function (v) {
        return !!v || 'Username is required';
      }, function (v) {
        return v && v.length <= 64 || 'Name must be less than 64 characters';
      }],
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      password: '',
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }],
      password2: '',
      password2Rules: [function (v) {
        return !!v || 'Password is required';
      }, function (v) {
        return v === _this.password || 'Passwords doesnot match';
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    submit: function submit() {
      var _this2 = this;

      if (this.$refs.form.validate()) {
        var path = '/admin/register';
        var data = {
          username: this.username,
          email: this.email,
          password: this.password
        };
        var auth = { username: this.authUsername, password: this.authPassword };
        this.$swal({
          title: 'Registration in Progress',
          onOpen: function onOpen() {
            // let that = this
            _this2.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post(path, data, auth).then(function (response) {
              if (response.data.status === 0) {
                _this2.clear();
                _this2.$swal(response.data.message);
              } else {
                _this2.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this2.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this2.$swal.isLoading();
          }
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),

/***/ "Lsjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-form',
  props: ['buttonName', 'editData', 'formTitle'],
  data: function data() {
    return {
      id: null,
      valid: true,
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }],
      icon: '',
      link: '',
      // telephoneRules: [
      //   v => /[+0-9]+$/.test(v) || 'Telephone must be valid',
      //   v => (v && v.length <= 12) || 'Telephone must be less than 12 characters'
      // ],
      // faxRules: [
      //   v => /[+0-9]+$/.test(v) || 'Fax must be valid',
      //   v => (v && v.length <= 12) || 'Fax must be less than 12 characters'
      // ],
      iconRules: [function (v) {
        return !!v || 'Icon is required';
      }, function (v) {
        return v && v.length <= 50 || 'Icon must be less than 50 characters';
      }],
      linkRules: [function (v) {
        return !!v || 'Link is required';
      }, function (v) {
        return v && v.length <= 120 || 'Link must be less than 120 characters';
      }],
      showIcon: true
    };
  },
  beforeMount: function beforeMount() {
    if (this.editData) {
      this.id = this.editData.id;
      this.name = this.editData.name ? this.editData.name : this.editData.headline;
      this.icon = this.editData.icon;
      this.link = this.editData.link;
      this.showIcon = this.editData.show;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  })),
  methods: {
    submit: function submit() {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          var data = {
            id: this.id,
            name: this.name,
            icon: this.icon,
            link: this.link,
            show_icon: this.showIcon,
            current_user: this.currentUser
          };
          this.$emit('addItem', data);
        }
      } else {
        if (this.$refs.form.validate()) {
          var _data = {
            id: this.id,
            name: this.name,
            icon: this.icon,
            link: this.link,
            show_icon: this.showIcon,
            current_user: this.currentUser
          };
          this.$emit('updateItem', this.editData.id, _data);
        }
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    }
  }
});

/***/ }),

/***/ "Lxuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AboutInputForm__ = __webpack_require__("8QNr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      designData: [],
      showDesignForm: false,
      editData: null,
      buttonName: 'Add',
      headers: [{
        text: 'Title',
        align: 'left',
        sortable: false,
        value: 'title'
      }, { text: 'Content', align: 'right', value: 'content' }, { text: 'Main Image', sortable: false, align: 'right', value: 'mainImage' }, { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' }, { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' }, { text: 'Edit', sortable: false, align: 'right', value: 'edit' }]
    };
  },

  components: {
    AboutInputForm: __WEBPACK_IMPORTED_MODULE_4__components_AboutInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getDesignData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getDesignData: function getDesignData() {
      var _this = this;

      var path = '/design';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.designData = response.data.design;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showDesignForm = !this.showDesignForm;
      this.buttonName = 'Add';
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      this.showDesignForm = !this.showDesignForm;
      this.buttonName = 'Update';
      this.editData = item;
    },
    addItem: function addItem(data, imageFile) {
      var _this2 = this;

      var path = '/design';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this2.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this2.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function (response) {
              if (response.data.status === 0) {
                _this2.$swal(response.data.message);
                _this2.showDesignForm = !_this2.showDesignForm;
                _this2.getDesignData();
              } else {
                _this2.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this2.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this2.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data, imageFile) {
      var _this3 = this;

      var path = '/design/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this3.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (response) {
            if (response.data.status === 0) {
              _this3.$swal(response.data.message);
              _this3.showDesignForm = !_this3.showDesignForm;
              _this3.getDesignData();
            } else {
              _this3.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this3.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item, index) {
      var _this4 = this;

      var path = '/design/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this4.getDesignData();
          _this4.$swal(response.data.message);
        } else {
          _this4.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this4.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71223d6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("aC2y");
function injectStyle (ssrContext) {
  __webpack_require__("a/w5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71223d6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MXg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageGallery_vue__ = __webpack_require__("3GzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7857c0b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageGallery_vue__ = __webpack_require__("IlA2");
function injectStyle (ssrContext) {
  __webpack_require__("+uyx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7857c0b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageGallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7857c0b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageGallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mbx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    hideVideo: function hideVideo() {
      this.$emit('hideVideo');
    }
  }
});

/***/ }),

/***/ "MfHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact-form',
  data: function data() {
    return {
      valid: true,
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }, function (v) {
        return v && v.length <= 10 || 'Name must be less than 10 characters';
      }],
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      telephone: '',
      telephoneRules: [function (v) {
        return !!v || 'Telephone is required';
      }, function (v) {
        return (/[+0-9]+$/.test(v) || 'Telephone must be valid'
        );
      }, function (v) {
        return v && v.length <= 12 || 'Telephone must be less than 12 characters';
      }],
      address: '',
      addressRules: [function (v) {
        return !!v || 'Address is required';
      }, function (v) {
        return v && v.length <= 50 || 'Address must be less than 50 characters';
      }],
      project: '',
      projectRules: [function (v) {
        return !!v || 'Project name is required';
      }, function (v) {
        return v && v.length <= 20 || 'Project name must be less than 20 characters';
      }],
      pricerange: '',
      pricerangeRules: [function (v) {
        return !!v || 'Price range is required';
      }, function (v) {
        return (/[0-9]+$/.test(v) || 'Price range must be valid'
        );
      }, function (v) {
        return v && v.length <= 8 || 'Price range name must be less than 8 characters';
      }],
      comments: '',
      sitekey: '6Lc68m0UAAAAAEG9SN8Q305csTmbBQhTF1MKckZz',
      gRecaptchaToken: ''
    };
  },
  mounted: function mounted() {
    this.initRecaptcha();
  },

  methods: {
    initRecaptcha: function initRecaptcha() {
      var self = this;
      setTimeout(function () {
        if (window.grecaptcha === undefined) {
          self.initRecaptcha();
        } else {
          window.grecaptcha.render('g-recaptcha', {
            sitekey: self.sitekey,
            badge: 'inline',
            callback: self.getToken
          });
        }
      }, 100);
    },
    getToken: function getToken(token) {
      this.gRecaptchaToken = token;
    },
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var path = '/contact';
        var data = {
          name: this.name,
          email: this.email,
          address: this.address,
          telephone: this.telephone,
          project: this.project,
          pricerange: this.pricerange,
          comments: this.comments,
          recaptcha_token: this.gRecaptchaToken
        };
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].post(path, data).then(function (response) {
          if (response.data.success) {
            var that = _this;
            that.clear();
            that.$swal('Contact Details Submitted Succefully!!');
            window.grecaptcha.reset();
          } else {
            // this.$swal('Error Submitting Contact Details!!')
            // window.grecaptcha.reset()
            _this.$swal(response.data.message);
          }
        });
        this.$swal('Contact Submission in Progress!!');
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),

/***/ "MnO0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "My2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"project-form"}},[_c('v-container',[(!_vm.showProjectDetailsForm)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.nameRules,"label":"Name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.descriptionRules,"label":"Description","required":"","textarea":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.locationRules,"label":"Location","required":""},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.grossRealisationRules,"label":"Gross Realisation","required":""},model:{value:(_vm.grossRealisation),callback:function ($$v) {_vm.grossRealisation=$$v},expression:"grossRealisation"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Completed On","hint":"DD/MM/YYYY","persistent-hint":"","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.computedDateFormatted),callback:function ($$v) {_vm.computedDateFormatted=$$v},expression:"computedDateFormatted"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.completedOn),callback:function ($$v) {_vm.completedOn=$$v},expression:"completedOn"}})],1),_c('br'),_vm._v("\n        Main Image"),_c('input',{attrs:{"type":"file","id":"file","name":"file"},on:{"change":function($event){_vm.onFileChange($event, 'main')}}}),_vm._v(" "),(_vm.imageFile)?_c('div',[_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.imageFile}}),_vm._v(" "),_c('v-icon',{on:{"click":function($event){_vm.removeImage('main')}}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v("\n        Parallax Image"),_c('input',{attrs:{"type":"file","id":"parallaxfile","name":"parallaxfile"},on:{"change":function($event){_vm.onFileChange($event, 'parallax')}}}),_vm._v(" "),(_vm.parallaxImageFile)?_c('div',[_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.parallaxImageFile}}),_vm._v(" "),_c('v-icon',{on:{"click":function($event){_vm.removeImage('parallax')}}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green"},on:{"click":_vm.showAddForm}},[_vm._v("+ Add Project Details")]),_c('br'),_vm._v(" "),(_vm.projectDetailsData.length > 0 && !_vm.showProjectDetailsForm)?_c('div',{staticStyle:{"width":"100%"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.projectDetailsData,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.headline))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.content.substring(0, 100)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("dateTimeFormat")(props.item.modified_on)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.author.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"fa primary small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"},on:{"click":function($event){_vm.showEditForm(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"fa dark small mx-3 white--text",attrs:{"icon":"","color":"grey lighten-1"},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("highlight_off")])],1)],1)]}}])})],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1):_c('ProjectDetailsForm',{attrs:{"formTitle":'Project Details',"buttonName":_vm.detailsButtonName,"editData":_vm.editDetailsData},on:{"addItem":_vm.showNewDetailsItem,"updateItem":_vm.showUpdatedDetailsItem,"goBack":function($event){_vm.showProjectDetailsForm = !_vm.showProjectDetailsForm}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert__ = __webpack_require__("f1Fh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css__ = __webpack_require__("e0XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__("gJtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_index_js__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);





// import 'bootstrap/dist/css/bootstrap.min.css'








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

// Date filter

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('yearFormat', function (value) {
  return __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).year();
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('longMonthYearFormat', function (value) {
  return __WEBPACK_IMPORTED_MODULE_11_moment___default()(value, 'DD/MM/YY').format('MMMM YYYY');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('dateTimeFormat', function (value) {
  return __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).date() + '/' + __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).month() + '/' + __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).year() + ' ' + __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).hours() + ':' + __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).minute() + ':' + __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).second();
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__store_index_js__["a" /* default */],
  components: {
    app: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]
  },
  render: function render(h) {
    return h('app');
  }
});

/***/ }),

/***/ "NahR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nw6D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ON+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceMenuItem_vue__ = __webpack_require__("yp8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba00a3c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceMenuItem_vue__ = __webpack_require__("BbHW");
function injectStyle (ssrContext) {
  __webpack_require__("zhgA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba00a3c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba00a3c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OUFY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.cards),function(card,cardIndex){return _c('v-flex',_vm._b({key:cardIndex,attrs:{"xs12":"","sm6":""}},'v-flex',( _obj = {}, _obj[("xs" + (_vm.cardFlex/2 * 3))] = true, _obj[("md" + _vm.cardFlex)] = true, _obj ),false),[_c('v-card',{attrs:{"hover":"","raised":""}},[_c('v-card-media',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + card.main_image,"height":"20vh"}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(card.name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(card.short_description ? card.short_description.substring(0, 70) + ' ...' : ' ...'))]),_c('br'),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Gross Realisation: ")]),_vm._v(_vm._s(card.gross_realisation))]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Date: ")]),_vm._v(_vm._s(_vm._f("yearFormat")(card.completed_on)))])])]),_vm._v(" "),_c('div',{staticClass:"overall-bottom-gradient",on:{"click":function($event){_vm.showProject(card)}}}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange","icon":""}},[_c('v-icon',[_vm._v("share")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange","icon":""}},[_c('v-icon',[_vm._v("info")])],1)],1)],1)],1)
var _obj;}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OaUx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OsYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletedDevInputForm_vue__ = __webpack_require__("bhPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f378fb50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompletedDevInputForm_vue__ = __webpack_require__("Cp9j");
function injectStyle (ssrContext) {
  __webpack_require__("OaUx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f378fb50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletedDevInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f378fb50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompletedDevInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oxs9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProjectInputForm__ = __webpack_require__("1QYN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      projectData: [],
      showProjectForm: false,
      editData: null,
      buttonName: 'Save',
      projectDetailsData: [],
      headers: [{
        text: 'Project',
        align: 'left',
        sortable: false,
        value: 'project'
      },
      // { text: 'Name', value: 'Name' },
      { text: 'Location', align: 'right', value: 'location' }, { text: 'Gross Realization', sortable: false, align: 'right', value: 'grossRealisation' }, { text: 'Completed on', sortable: false, align: 'right', value: 'completedOn' }, { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' }, { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' }, { text: 'Edit', sortable: false, align: 'right', value: 'edit' }]
    };
  },

  components: {
    ProjectInputForm: __WEBPACK_IMPORTED_MODULE_4__components_ProjectInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getProjectData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getProjectData: function getProjectData() {
      var _this = this;

      var path = '/project';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.projectData = response.data.project;
          _this.projectDetailsData = response.data.project_details;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showProjectForm = !this.showProjectForm;
      // this.buttonName = 'Save'
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      var _this2 = this;

      this.showProjectForm = !this.showProjectForm;
      // this.buttonName = 'Update'
      this.editData = item;
      this.editData.projectDetails = [];
      this.projectDetailsData.forEach(function (el) {
        if (el.project.id === item.id) {
          _this2.editData.projectDetails.push(el);
        }
      });
    },
    addItem: function addItem(data, imageFile, imageFile2) {
      var _this3 = this;

      var path = '/project';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('parallax_image', imageFile2.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this3.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this3.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function (response) {
              if (response.data.status === 0) {
                _this3.$swal(response.data.message);
                _this3.showProjectForm = !_this3.showProjectForm;
                _this3.getProjectData();
              } else {
                _this3.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this3.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this3.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data, imageFile, imageFile2) {
      var _this4 = this;

      var path = '/project/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('parallax_image', imageFile2.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this4.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (response) {
            if (response.data.status === 0) {
              _this4.$swal(response.data.message);
              _this4.showProjectForm = !_this4.showProjectForm;
              _this4.getProjectData();
            } else {
              _this4.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this4.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this4.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item) {
      var _this5 = this;

      var path = '/project/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this5.getProjectData();
          _this5.$swal(response.data.message);
        } else {
          _this5.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this5.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "P02B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ParallaxHeader__ = __webpack_require__("A+Hu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BuzzGallery__ = __webpack_require__("1ns2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import ImageGallery from '@/components/ImageGallery'



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      gallery: []
    };
  },
  beforeMount: function beforeMount() {
    this.getGalleryData();
  },

  components: {
    ParallaxHeader: __WEBPACK_IMPORTED_MODULE_0__components_ParallaxHeader__["a" /* default */],
    // ImageGallery
    BuzzGallery: __WEBPACK_IMPORTED_MODULE_1__components_BuzzGallery__["a" /* default */]
  },
  methods: {
    getGalleryData: function getGalleryData() {
      var _this = this;

      // console.log(projectID)
      var path = '/image-gallery';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.imagegallery[0].project_details)
          response.data.imagegallery.forEach(function (el) {
            _this.gallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name });
          });
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal({
          'type': 'error',
          'title': error.toString().substring(0, 100)
        });
      });
    }
  }
});

/***/ }),

/***/ "P27z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Experience Item Image Gallery")]),_vm._v(" "),(!_vm.showAboutForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.experienceData.length > 0 && !_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-tabs',{attrs:{"color":"grey lighten-2","left":""}},_vm._l((_vm.experienceData),function(item,i){return _c('v-tab',{key:i,on:{"click":function($event){_vm.showActiveProject(i, item)}}},[_vm._v("\n            "+_vm._s(item.title)+"\n          ")])})),_vm._v(" "),(_vm.experienceDetailsData.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","lg3":""}},[_c('v-card',[_c('v-list',{staticClass:"grey lighten-3"},_vm._l((_vm.experienceDetailsData),function(item,itemIndex){return _c('v-list-tile',{key:itemIndex,on:{"click":function($event){_vm.showDetailsTab(itemIndex, item.id)}}},[_c('v-list-tile-action',[(_vm.paraIndex === itemIndex)?_c('v-icon',[_vm._v("star")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-title',{staticStyle:{"text-transform":"uppercase","font-size":"10pt","font-weight":"bold","color":"#676767","margin-left":"-20px"},domProps:{"textContent":_vm._s(item.headline)}})],1)}))],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getImagePerPage),function(image,imgIndex){return (_vm.aboutData.length > 0)?_c('v-flex',{key:imgIndex,attrs:{"x2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',{staticStyle:{"position":"relative"}},[_c('img',{staticStyle:{"width":"200px","height":"200px"},attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + image.name}}),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified on: "+_vm._s(_vm._f("dateTimeFormat")(image.modified_on)))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified by: "+_vm._s(image.author.email))]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","dark":""},on:{"click":function($event){_vm.deleteItem(image, imgIndex)}}},[_c('v-icon',[_vm._v("highlight_off")]),_vm._v("Remove")],1)],1)],1)],1):_vm._e()})),_vm._v(" "),(_vm.aboutData.length === 0)?_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-card',[_c('v-card-title',[_vm._v("\n                    No Images\n                    ")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-pagination',{attrs:{"length":Math.ceil(_vm.aboutData.length/_vm.imagesPerPage),"circle":""},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)],1)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('MultipleImageInputForm',{attrs:{"buttonName":_vm.buttonName},on:{"addItem":_vm.addItem,"goBack":function($event){_vm.showAboutForm = !_vm.showAboutForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PLxP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PknD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"social-links-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Social Links")]),_vm._v(" "),(!_vm.showAboutForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.aboutData.length > 0 && !_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","md9":"","offset-md3":"","offset-lg1":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.aboutData,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-icon',[_vm._v(_vm._s(props.item.icon))])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.link))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(props.item.show)?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("thumb_up")]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v("thumb_down")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("dateTimeFormat")(props.item.modified_on)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.author.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"fa primary small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"},on:{"click":function($event){_vm.showEditForm(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"fa dark small mx-3 white--text",attrs:{"icon":"","color":"grey lighten-1"},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("highlight_off")])],1)],1)]}}])})],1):_vm._e(),_vm._v(" "),(_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('SocialLinksInputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"goBack":function($event){_vm.showAboutForm = !_vm.showAboutForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PtFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CompanyContactInputForm__ = __webpack_require__("ENl5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: [],
      showAboutForm: false,
      editData: null,
      buttonName: 'Add',
      headers: [{
        text: 'Title',
        align: 'left',
        sortable: false,
        value: 'title'
      }, { text: 'Address', align: 'right', value: 'address' }, { text: 'Telephone', align: 'right', value: 'telephone' }, { text: 'Fax', align: 'right', value: 'fax' }, { text: 'Email', align: 'right', value: 'email' }, { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' }, { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' }, { text: 'Edit', sortable: false, align: 'right', value: 'edit' }]
    };
  },

  components: {
    ContactInputForm: __WEBPACK_IMPORTED_MODULE_4__components_CompanyContactInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getAboutData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getAboutData: function getAboutData() {
      var _this = this;

      var path = '/company-contact';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          _this.aboutData = response.data.companycontact;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Add';
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Update';
      this.editData = item;
    },
    addItem: function addItem(data) {
      var _this2 = this;

      var path = '/company-contact';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      // formData.append('image', imageFile.files[0])
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this2.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this2.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth).then(function (response) {
              if (response.data.status === 0) {
                _this2.$swal(response.data.message);
                _this2.showAboutForm = !_this2.showAboutForm;
                _this2.getAboutData();
              } else {
                _this2.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this2.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this2.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data) {
      var _this3 = this;

      var path = '/company-contact/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      // formData.append('image', imageFile.files[0])
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this3.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth).then(function (response) {
            if (response.data.status === 0) {
              _this3.$swal(response.data.message);
              _this3.showAboutForm = !_this3.showAboutForm;
              _this3.getAboutData();
            } else {
              _this3.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this3.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item, index) {
      var _this4 = this;

      var path = '/company-contact/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this4.getAboutData();
          _this4.$swal(response.data.message);
        } else {
          _this4.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this4.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "Pyrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q49J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QAKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletedDevelopment_vue__ = __webpack_require__("aTki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_552d1ed4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompletedDevelopment_vue__ = __webpack_require__("n1O5");
function injectStyle (ssrContext) {
  __webpack_require__("VBXR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-552d1ed4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletedDevelopment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_552d1ed4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompletedDevelopment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QMjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignsPage_vue__ = __webpack_require__("hmhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075f2306_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignsPage_vue__ = __webpack_require__("iwm3");
function injectStyle (ssrContext) {
  __webpack_require__("hToL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-075f2306"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075f2306_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RCcb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminHomePage_vue__ = __webpack_require__("IdEL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef08c1c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminHomePage_vue__ = __webpack_require__("lqHB");
function injectStyle (ssrContext) {
  __webpack_require__("kFA9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ef08c1c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminHomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef08c1c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminHomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rnn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jumbotron_vue__ = __webpack_require__("u2ks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c88716d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jumbotron_vue__ = __webpack_require__("kmiY");
function injectStyle (ssrContext) {
  __webpack_require__("wUKj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c88716d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jumbotron_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c88716d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jumbotron_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RuZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyrightComponent_vue__ = __webpack_require__("BTQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4931004c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyrightComponent_vue__ = __webpack_require__("8wF2");
function injectStyle (ssrContext) {
  __webpack_require__("qpZp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4931004c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyrightComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4931004c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyrightComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SDxu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sf33":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TbzR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UPDATE_PROJECT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_PROJECT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_PROJECT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_PROJECT_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_PROJECT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_DESIGN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_AUTH_DATA; });
var UPDATE_PROJECT = 'UPDATE_PROJECT';
var UPDATE_PROJECT_ID = 'UPDATE_PROJECT_ID';
var UPDATE_PROJECT_NAME = 'UPDATE_PROJECT_NAME';
var UPDATE_PROJECT_LOCATION = 'UPDATE_PROJECT_LOCATION';
var UPDATE_PROJECT_DETAIL = 'UPDATE_PROJECT_DETAIL';
var UPDATE_DESIGN_NAME = 'UPDATE_DESIGN_NAME';
var LOGIN = 'LOGIN';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT = 'LOGOUT';
var UPDATE_AUTH_DATA = 'UPDATE_AUTH_DATA';

/***/ }),

/***/ "Tis/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseImageGallery_vue__ = __webpack_require__("Ujzf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3577b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseImageGallery_vue__ = __webpack_require__("FDXK");
function injectStyle (ssrContext) {
  __webpack_require__("PLxP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b3577b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseImageGallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3577b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseImageGallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U1sW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UPH+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ujzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    }
  },

  watch: {
    loginStatus: function loginStatus() {
      if (!this.loginStatus) {
        this.$router.push('/admin/login');
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    logout: 'adminUser/logout'
  }))
});

/***/ }),

/***/ "V/Gv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ParallaxHeader__ = __webpack_require__("A+Hu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImageGallery__ = __webpack_require__("MXg3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BuzzTube__ = __webpack_require__("mO8d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      experienceData: [{ 'title': '', 'content': '' }],
      index: 0,
      paraIndex: 0,
      imageGallery: [],
      detailsGallery: [],
      showDetailsGallery: false,
      experienceDetails: [],
      videos: [],
      showVideoGallery: false
    };
  },

  components: {
    ParallaxHeader: __WEBPACK_IMPORTED_MODULE_0__components_ParallaxHeader__["a" /* default */],
    ImageGallery: __WEBPACK_IMPORTED_MODULE_1__components_ImageGallery__["a" /* default */],
    BuzzTube: __WEBPACK_IMPORTED_MODULE_2__components_BuzzTube__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.getExperienceData();
  },

  methods: {
    getExperienceData: function getExperienceData() {
      var _this = this;

      var path = '/experience';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.experienceData = response.data.experience;
          // this.experienceDetails = response.data.experience_details
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    getExperienceDetailsData: function getExperienceDetailsData(detailsID) {
      var _this2 = this;

      var path = '/experience/' + detailsID;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this2.experienceDetails = response.data.experience_details;
          _this2.getGalleryData(detailsID);
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    },
    showExperienceItem: function showExperienceItem(index, experience) {
      this.paraIndex = 0;
      this.detailsGallery = [];
      this.imageGallery = [];
      this.index = index;
      if (experience.title.toLowerCase() !== 'videos') {
        this.getExperienceDetailsData(this.experienceData[index].id);
      } else {
        this.getVideosData();
      }
    },
    showDetailsTab: function showDetailsTab(itemIndex, detailsID) {
      var _this3 = this;

      this.detailsGallery = [];
      this.imageGallery.forEach(function (el) {
        if (el.experience_details.id === detailsID) {
          // this.detailsGallery.push('https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name)
          // this.detailsGallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'experience': el.experience.name, 'experience_details': el.experience_details.headline })
          _this3.detailsGallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.experience.title, 'project_details': el.experience_details.headline });
        }
      });
      if (this.detailsGallery.length > 0) {
        this.showDetailsGallery = true;
      } else {
        this.showDetailsGallery = false;
      }
      this.paraIndex = itemIndex;
    },
    getGalleryData: function getGalleryData(itemID) {
      var _this4 = this;

      this.detailsGallery = [];
      var path = '/experience-image-gallery/' + itemID;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this4.imageGallery = response.data.imagegallery;
          _this4.imageGallery.forEach(function (el) {
            if (el.experience_details.id === _this4.experienceDetails[_this4.paraIndex].id) {
              _this4.detailsGallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.experience.title, 'project_details': el.experience_details.headline });
            }
          });
          if (_this4.detailsGallery.length > 0) {
            _this4.showDetailsGallery = true;
          } else {
            _this4.showDetailsGallery = false;
          }
        } else {
          _this4.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this4.$swal(error.toString().substring(0, 100));
      });
    },
    getVideosData: function getVideosData() {
      var _this5 = this;

      var path = '/video-gallery/experience';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this5.videos = response.data.videos;
        } else {
          _this5.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this5.$swal(error.toString().substring(0, 100));
      });
    },
    showVideo: function showVideo(index) {
      this.videoIndex = index;
      this.showVideoGallery = !this.showVideoGallery;
    }
  }
});

/***/ }),

/***/ "V5/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CompletedDevInputForm__ = __webpack_require__("OsYc");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      designData: [],
      showDesignForm: false,
      editData: null,
      buttonName: 'Add'
    };
  },

  components: {
    CompletedDevInputForm: __WEBPACK_IMPORTED_MODULE_4__components_CompletedDevInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getDesignData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getDesignData: function getDesignData() {
      var _this = this;

      var path = '/completed-dev';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.designData = response.data.completeddev;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showDesignForm = !this.showDesignForm;
      this.buttonName = 'Add';
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      this.showDesignForm = !this.showDesignForm;
      this.buttonName = 'Update';
      this.editData = item;
    },
    addItem: function addItem(data) {
      var _this2 = this;

      var path = '/completed-dev';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      // formData.append('image', imageFile.files[0])
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this2.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this2.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function (response) {
              if (response.data.status === 0) {
                _this2.$swal(response.data.message);
                _this2.showDesignForm = !_this2.showDesignForm;
                _this2.getDesignData();
              } else {
                _this2.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this2.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this2.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data) {
      var _this3 = this;

      var path = '/completed-dev/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      // formData.append('image', imageFile.files[0])
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this3.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (response) {
            if (response.data.status === 0) {
              _this3.$swal(response.data.message);
              _this3.showDesignForm = !_this3.showDesignForm;
              _this3.getDesignData();
            } else {
              _this3.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this3.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item, index) {
      var _this4 = this;

      var path = '/completed-dev/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this4.getDesignData();
          _this4.$swal(response.data.message);
        } else {
          _this4.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this4.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "VBXR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VE9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ExpMultipleImageInputForm__ = __webpack_require__("XPmj");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: [],
      showAboutForm: false,
      buttonName: 'Add',
      experienceData: [],
      experienceDetails: [],
      activeProject: 0,
      paraIndex: 0,
      page: 1,
      imagesPerPage: 9,
      activeProjectID: '',
      activeDetailsID: ''
    };
  },

  components: {
    MultipleImageInputForm: __WEBPACK_IMPORTED_MODULE_4__components_ExpMultipleImageInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getProjectData();
    }
  },

  watch: {
    activeProject: function activeProject() {
      this.aboutData = [];
      this.paraIndex = 0;
      this.page = 1;
      this.activeProjectID = '';
      this.activeDetailsID = '';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  }), {
    experienceDetailsData: function experienceDetailsData() {
      return this.getProjectDetails();
    },
    getImagePerPage: function getImagePerPage() {
      return this.aboutData.slice((this.page - 1) * this.imagesPerPage, this.imagesPerPage * this.page);
    }
  }),
  methods: {
    getProjectDetails: function getProjectDetails() {
      var _this = this;

      var details = [];
      if (this.experienceDetails.length > 0) {
        this.experienceDetails.forEach(function (el) {
          if (el.experience.id === _this.experienceData[_this.activeProject].id) {
            details.push(el);
          }
        });
      }
      return details;
    },
    getProjectData: function getProjectData() {
      var _this2 = this;

      var path = '/experience';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this2.experienceData = response.data.experience;
          _this2.experienceDetails = response.data.experience_details;
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    },
    getAboutData: function getAboutData(experienceID, experienceDetailsID) {
      var _this3 = this;

      var path = '/experience-image-gallery/' + experienceID + '/' + experienceDetailsID;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          // console.log(response.data)
          _this3.aboutData = response.data.imagegallery;
        } else {
          _this3.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this3.$swal(error.toString().substring(0, 100));
      });
    },
    showActiveProject: function showActiveProject(index, item) {
      this.activeProject = index;
      this.showDetailsTab(index, item);
    },
    showDetailsTab: function showDetailsTab(itemIndex, detailsID) {
      this.page = 1;
      this.activeDetailsID = detailsID;
      this.paraIndex = itemIndex;
      this.activeProjectID = this.experienceData[this.activeProject].id;
      this.getAboutData(this.activeProjectID, detailsID);
    },
    showAddForm: function showAddForm() {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Add';
    },
    addItem: function addItem(data, imageFile) {
      var _this4 = this;

      var path = '/experience-image-gallery';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      var imageFileArr = [];
      for (var i = 0; i < imageFile.files.length; i++) {
        imageFileArr.push(imageFile.files[i]);
      }
      [].forEach.call(imageFile.files, function (file, index) {
        formData.append('image' + index, file);
      });
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this4.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this4.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function (response) {
              if (response.data.status === 0) {
                _this4.$swal(response.data.message);
                _this4.showAboutForm = !_this4.showAboutForm;
                _this4.getAboutData();
              } else {
                _this4.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this4.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this4.$swal.isLoading();
          }
        });
      });
    },
    deleteItem: function deleteItem(item, index) {
      var _this5 = this;

      var path = '/experience-image-gallery/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this5.getAboutData(_this5.activeProjectID, _this5.activeDetailsID);
          _this5.$swal(response.data.message);
        } else {
          _this5.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this5.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "VS4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsCard_vue__ = __webpack_require__("EKYD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa0e778_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsCard_vue__ = __webpack_require__("ILp5");
function injectStyle (ssrContext) {
  __webpack_require__("7SzN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4aa0e778"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa0e778_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VVqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WwMi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XHoX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XPmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpMultipleImageInputForm_vue__ = __webpack_require__("YEcG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56491c21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpMultipleImageInputForm_vue__ = __webpack_require__("zuhU");
function injectStyle (ssrContext) {
  __webpack_require__("wRjz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56491c21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpMultipleImageInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56491c21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpMultipleImageInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XZBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XyWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-footer',{staticClass:"grey darken-4 pa-3",attrs:{"height":"auto"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","py-3":"","text-xs-center":"","white--text":""}},[_c('CopyrightComponent')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YEcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['buttonName', 'editData', 'formTitle'],
  data: function data() {
    return {
      projectSelected: null,
      projectDetailsSelected: null,
      id: null,
      valid: true,
      imageFile: '',
      projectItems: [],
      projectDetailsItems: []
    };
  },
  beforeMount: function beforeMount() {
    this.getProjectsData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  })),
  watch: {
    projectSelected: function projectSelected() {
      this.projectDetailsItems = [];
      if (this.projectSelected !== null) {
        this.getProjectDetails(this.projectSelected.id);
      }
    }
  },
  methods: {
    getProjectsData: function getProjectsData() {
      var _this = this;

      var path = '/experience';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // this.projects = response.data.project
          response.data.experience.forEach(function (el) {
            _this.projectItems.push({ text: el.title, id: el.id });
          });
          // this.projectDetails = response.data.project_details
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    getProjectDetails: function getProjectDetails(projectID) {
      var _this2 = this;

      var path = '/experience/' + projectID;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          response.data.experience_details.forEach(function (el) {
            _this2.projectDetailsItems.push({ text: el.headline, id: el.id });
          });
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    },
    submit: function submit() {
      if (this.$refs.form.validate()) {
        var data = {
          id: this.id,
          experience_id: this.projectSelected.id,
          experience_details_id: this.projectDetailsSelected.id,
          current_user: this.currentUser
        };
        var imageInput = this.$el.querySelector('#file');
        this.$emit('addItem', data, imageInput);
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.imageFile = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function removeImage(e) {
      var imageInput = this.$el.querySelector('#file');
      imageInput.value = '';
      this.imageFile = '';
    }
  }
});

/***/ }),

/***/ "YR12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_FrontPage__ = __webpack_require__("+tB8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_ContactsPage__ = __webpack_require__("biB/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_AboutPage__ = __webpack_require__("lje2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_ProjectsPage__ = __webpack_require__("5zRc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ProjectDetailPage__ = __webpack_require__("xiLr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_DesignsPage__ = __webpack_require__("QMjW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ExperiencePage__ = __webpack_require__("Bpe0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ImageGalleryPage__ = __webpack_require__("E4v1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_VideoPlayer__ = __webpack_require__("Jv72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__admin_pages_AdminHomePage__ = __webpack_require__("RCcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__admin_pages_LoginPage__ = __webpack_require__("sQi3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admin_pages_RegistrationPage__ = __webpack_require__("Cxol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__admin_pages_AboutMenuItem__ = __webpack_require__("D5ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__admin_pages_DesignMenuItem__ = __webpack_require__("07iq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__admin_pages_ProjectsMenuItem__ = __webpack_require__("KqOE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__admin_pages_ExperienceMenuItem__ = __webpack_require__("ON+F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__admin_pages_CompletedDevMenuItem__ = __webpack_require__("sy1D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__admin_pages_SliderImagesMenuItem__ = __webpack_require__("Ez/3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__admin_pages_ChooseImageGallery__ = __webpack_require__("Tis/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__admin_pages_ImageGalleryMenuItem__ = __webpack_require__("ACdr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__admin_pages_ExperienceImageGalleryMenuItem__ = __webpack_require__("2GXe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__admin_pages_CompanyContactMenuItem__ = __webpack_require__("KfQs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__admin_pages_SocialLinksMenuItem__ = __webpack_require__("7ewF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__admin_pages_VideoGalleryMenuItem__ = __webpack_require__("dZ0y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_NotFoundPage__ = __webpack_require__("x7AD");



























// const routerOptions = [
//   { path: '/', component: 'Home' },
//   { path: '/about', component: 'About' }
// ]

// const routes = routerOptions.map(route => {
//   return {
//     ...route,
//     component: () => import(`@/components/${route.component}.vue`)
//   }
// })

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'FrontPage',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_FrontPage__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_ContactsPage__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_AboutPage__["a" /* default */]
  }, {
    path: '/works',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_ProjectsPage__["a" /* default */]
  }, {
    path: '/works/:name',
    name: 'Project Details',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_ProjectDetailPage__["a" /* default */]
  }, {
    path: '/design',
    name: 'Design',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_DesignsPage__["a" /* default */]
  }, {
    path: '/experience',
    name: 'Experience',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_ExperiencePage__["a" /* default */]
  }, {
    path: '/gallery',
    name: 'Image Gallery',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_ImageGalleryPage__["a" /* default */]
  }, {
    path: '/video-player',
    name: 'Video Player',
    component: __WEBPACK_IMPORTED_MODULE_10__components_VideoPlayer__["a" /* default */]
  }, {
    path: '/admin',
    name: 'Admin Home',
    component: __WEBPACK_IMPORTED_MODULE_11__admin_pages_AdminHomePage__["a" /* default */]
  }, {
    path: '/admin/login',
    name: 'Admin Login',
    component: __WEBPACK_IMPORTED_MODULE_12__admin_pages_LoginPage__["a" /* default */]
  }, {
    path: '/admin/register',
    name: 'Admin Register',
    component: __WEBPACK_IMPORTED_MODULE_13__admin_pages_RegistrationPage__["a" /* default */]
  }, {
    path: '/admin/about',
    name: 'Admin About Menu Items',
    component: __WEBPACK_IMPORTED_MODULE_14__admin_pages_AboutMenuItem__["a" /* default */]
  }, {
    path: '/admin/design',
    name: 'Admin Design Menu Items',
    component: __WEBPACK_IMPORTED_MODULE_15__admin_pages_DesignMenuItem__["a" /* default */]
  }, {
    path: '/admin/project',
    name: 'Admin Project Menu Items',
    component: __WEBPACK_IMPORTED_MODULE_16__admin_pages_ProjectsMenuItem__["a" /* default */]
  }, {
    path: '/admin/experience',
    name: 'Admin Experience Menu Items',
    component: __WEBPACK_IMPORTED_MODULE_17__admin_pages_ExperienceMenuItem__["a" /* default */]
  }, {
    path: '/admin/completed-dev',
    name: 'Admin Completed Menu Items',
    component: __WEBPACK_IMPORTED_MODULE_18__admin_pages_CompletedDevMenuItem__["a" /* default */]
  }, {
    path: '/admin/slider-images',
    name: 'Admin Slider Items',
    component: __WEBPACK_IMPORTED_MODULE_19__admin_pages_SliderImagesMenuItem__["a" /* default */]
  }, {
    path: '/admin/image-gallery',
    name: 'Admin Image Gallery Items',
    component: __WEBPACK_IMPORTED_MODULE_20__admin_pages_ChooseImageGallery__["a" /* default */]
  }, {
    path: '/admin/project-image-gallery',
    name: 'Admin Project Image Gallery Items',
    component: __WEBPACK_IMPORTED_MODULE_21__admin_pages_ImageGalleryMenuItem__["a" /* default */]
  }, {
    path: '/admin/experience-image-gallery',
    name: 'Admin Experience Image Gallery Items',
    component: __WEBPACK_IMPORTED_MODULE_22__admin_pages_ExperienceImageGalleryMenuItem__["a" /* default */]
  }, {
    path: '/admin/company-contact',
    name: 'Admin company contact Items',
    component: __WEBPACK_IMPORTED_MODULE_23__admin_pages_CompanyContactMenuItem__["a" /* default */]
  }, {
    path: '/admin/social-links',
    name: 'Admin Social Links Items',
    component: __WEBPACK_IMPORTED_MODULE_24__admin_pages_SocialLinksMenuItem__["a" /* default */]
  }, {
    path: '/admin/video-gallery',
    name: 'Admin Video Gallery Items',
    component: __WEBPACK_IMPORTED_MODULE_25__admin_pages_VideoGalleryMenuItem__["a" /* default */]
  },
  // {
  //   path: '/awards',
  //   name: 'Awards',
  //   component: Awards
  // },
  // {
  //   path: '/sponsorship',
  //   name: 'Sponsorship',
  //   component: Sponsorship
  // },
  {
    path: '*',
    name: '404 Page',
    component: __WEBPACK_IMPORTED_MODULE_26__pages_NotFoundPage__["a" /* default */]
  }],
  mode: 'history' // Removes '#/' from the URL
}));

/***/ }),

/***/ "ZH30":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-form',
  props: ['buttonName', 'editData', 'formTitle'],
  data: function data() {
    return {
      id: null,
      valid: true,
      title: '',
      titleRules: [function (v) {
        return !!v || 'Title is required';
      }],
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      telephone: '',
      fax: '',
      // telephoneRules: [
      //   v => /[+0-9]+$/.test(v) || 'Telephone must be valid',
      //   v => (v && v.length <= 12) || 'Telephone must be less than 12 characters'
      // ],
      // faxRules: [
      //   v => /[+0-9]+$/.test(v) || 'Fax must be valid',
      //   v => (v && v.length <= 12) || 'Fax must be less than 12 characters'
      // ],
      address: ''
      // addressRules: [
      //   v => (v && v.length <= 50) || 'Address must be less than 50 characters'
      // ]
    };
  },
  beforeMount: function beforeMount() {
    if (this.editData) {
      this.id = this.editData.id;
      this.title = this.editData.title ? this.editData.title : this.editData.headline;
      this.address = this.editData.address;
      this.telephone = this.editData.telephone;
      this.fax = this.editData.fax;
      this.email = this.editData.email;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  })),
  methods: {
    submit: function submit() {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          var data = {
            id: this.id,
            title: this.title,
            address: this.address,
            telephone: this.telephone,
            fax: this.fax,
            email: this.email,
            current_user: this.currentUser
          };
          this.$emit('addItem', data);
        }
      } else {
        if (this.$refs.form.validate()) {
          var _data = {
            id: this.id,
            title: this.title,
            address: this.address,
            telephone: this.telephone,
            fax: this.fax,
            email: this.email,
            current_user: this.currentUser
          };
          this.$emit('updateItem', this.editData.id, _data);
        }
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    }
  }
});

/***/ }),

/***/ "ZlrH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__("TbzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__design_tabs_js__ = __webpack_require__("qbg5");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    name: 'Test Design',
    details: {},
    gotDetails: false,
    tabs: []
  },
  getters: {
    getActiveDesignName: function getActiveDesignName(state) {
      return state.name;
    },
    getActiveDesignDetails: function getActiveDesignDetails(state) {
      __WEBPACK_IMPORTED_MODULE_2__design_tabs_js__["a" /* DESIGN_TABS */].forEach(function (item) {
        if (item.name === state.name) {
          state.details = item;
          state.gotDetails = true;
        } else {
          if (!state.gotDetails) {
            state.details = {};
          }
        }
      });
      return state.details;
    },
    getDesignTabs: function getDesignTabs(state) {
      state.tabs = __WEBPACK_IMPORTED_MODULE_2__design_tabs_js__["a" /* DESIGN_TABS */];
      return state.tabs;
    }
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["e" /* UPDATE_DESIGN_NAME */], function (state, designName) {
    state.name = designName;
  }),
  actions: {
    updateActiveDesignName: function updateActiveDesignName(_ref, designName) {
      var commit = _ref.commit;

      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["e" /* UPDATE_DESIGN_NAME */], designName);
    }
  }
});

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: []
    };
  },
  beforeMount: function beforeMount() {
    this.getAboutData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getAboutData: function getAboutData() {
      var _this = this;

      var path = '/about';
      var auth = {
        username: this.authUsername,
        passsword: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.aboutData = response.data.about;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "a/w5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a6Zp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aC2y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"light":""}},[(_vm.$route.path.indexOf('admin') === -1)?_c('NavigationComponent'):_c('DashBoardNav'),_vm._v(" "),(_vm.$route.path.indexOf('admin') !== -1 && _vm.$route.path.indexOf('login') === -1)?_c('DashBoardNavDrawer'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('router-view')],1),_vm._v(" "),(_vm.$route.path.indexOf('admin') === -1)?_c('FooterComponent'):_c('DashBoardFooter')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aFiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ContactForm_vue__ = __webpack_require__("wCbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CopyrightComponent_vue__ = __webpack_require__("RuZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ParallaxHeader__ = __webpack_require__("A+Hu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: []
    };
  },

  components: {
    'contact-form': __WEBPACK_IMPORTED_MODULE_0__components_ContactForm_vue__["a" /* default */],
    'copyright-component': __WEBPACK_IMPORTED_MODULE_1__components_CopyrightComponent_vue__["a" /* default */],
    ParallaxHeader: __WEBPACK_IMPORTED_MODULE_2__components_ParallaxHeader__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.getContactsData();
  },

  methods: {
    getContactsData: function getContactsData() {
      var _this = this;

      var path = '/company-contact';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          _this.aboutData = response.data.companycontact;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "aTki":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      cardFlex: 4,
      projects: []
    };
  },
  beforeMount: function beforeMount() {
    this.getDevData();
  },

  methods: {
    getDevData: function getDevData() {
      var _this = this;

      var path = '/completed-dev';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.projects = response.data.completeddev;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "axkb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bS7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__("TbzR");



var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    name: '',
    id: sessionStorage.getItem('projectID') ? sessionStorage.getItem('projectID') : '',
    location: sessionStorage.getItem('projectLocation') ? sessionStorage.getItem('projectLocation') : '',
    details: sessionStorage.getItem('projectToken') ? sessionStorage.getItem('projectToken') : []
  },
  getters: {
    getActiveProjectID: function getActiveProjectID(state) {
      return state.id;
    },
    getActiveProjectName: function getActiveProjectName(state) {
      return state.name;
    },
    getActiveProjectDetails: function getActiveProjectDetails(state) {
      return JSON.parse(state.details);
    },
    getActiveProjectLocation: function getActiveProjectLocation(state) {
      return state.location;
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["i" /* UPDATE_PROJECT_NAME */], function (state, projectName) {
    state.name = projectName;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["g" /* UPDATE_PROJECT_ID */], function (state, projectID) {
    sessionStorage.setItem('projectID', projectID);
    state.id = sessionStorage.getItem('projectID');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["h" /* UPDATE_PROJECT_LOCATION */], function (state, projectLocation) {
    sessionStorage.setItem('projectLocation', projectLocation);
    state.location = sessionStorage.getItem('projectLocation');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["f" /* UPDATE_PROJECT_DETAIL */], function (state, projectDetail) {
    sessionStorage.setItem('projectToken', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(projectDetail));
    state.details = sessionStorage.getItem('projectToken');
  }), _mutations),
  actions: {
    updateActiveProjectName: function updateActiveProjectName(_ref, projectName) {
      var commit = _ref.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["i" /* UPDATE_PROJECT_NAME */], projectName);
    },
    updateActiveProjectLocation: function updateActiveProjectLocation(_ref2, projectLocation) {
      var commit = _ref2.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["h" /* UPDATE_PROJECT_LOCATION */], projectLocation);
    },
    updateActiveProjectID: function updateActiveProjectID(_ref3, projectID) {
      var commit = _ref3.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["g" /* UPDATE_PROJECT_ID */], projectID);
    },
    updateActiveProjectDetails: function updateActiveProjectDetails(_ref4, projectDetail) {
      var commit = _ref4.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["f" /* UPDATE_PROJECT_DETAIL */], projectDetail);
    }
  }
});

/***/ }),

/***/ "bhPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-form',
  props: ['buttonName', 'editData', 'formTitle'],
  data: function data() {
    return {
      id: null,
      valid: true,
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }],
      address: '',
      addressRules: [function (v) {
        return !!v || 'Address is required';
      }],
      property: '',
      propertyRules: [function (v) {
        return !!v || 'Property is required';
      }],
      completedOn: ''
    };
  },
  beforeMount: function beforeMount() {
    if (this.editData) {
      this.id = this.editData.id;
      this.name = this.editData.name;
      this.address = this.editData.address;
      this.property = this.editData.properties;
      this.completedOn = this.editData.completed;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  }), {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.completedOn);
    }
  }),
  watch: {
    completedOn: function completedOn() {
      this.dateFormatted = this.formatDate(this.completedOn);
    }
  },
  methods: {
    submit: function submit() {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          var data = {
            id: this.id,
            name: this.name,
            address: this.address,
            properties: this.property,
            completed_on: this.computedDateFormatted,
            current_user: this.currentUser
          };
          this.$emit('addItem', data);
        }
      } else {
        if (this.$refs.form.validate()) {
          var _data = {
            id: this.id,
            name: this.name,
            address: this.address,
            properties: this.property,
            completed_on: this.computedDateFormatted,
            current_user: this.currentUser
          };
          this.$emit('updateItem', this.editData.id, _data);
        }
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    }
  }
});

/***/ }),

/***/ "biB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactsPage_vue__ = __webpack_require__("aFiX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0de35c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsPage_vue__ = __webpack_require__("2J6Z");
function injectStyle (ssrContext) {
  __webpack_require__("tQtI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e0de35c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0de35c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e69be2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("ASvC");
function injectStyle (ssrContext) {
  __webpack_require__("axkb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84e69be2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e69be2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dLe3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login-form"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.emailRules,"label":"Enter your Email address","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.passwordRules,"append-icon":_vm.e1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1)},"type":_vm.e1 ? 'password' : 'text',"name":"input-10-1","label":"Enter your password","hint":"At least 8 characters","min":"8","counter":"","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Submit")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dZ0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoGalleryMenuItem_vue__ = __webpack_require__("uv19");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12400f03_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoGalleryMenuItem_vue__ = __webpack_require__("HVta");
function injectStyle (ssrContext) {
  __webpack_require__("MnO0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12400f03"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoGalleryMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12400f03_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoGalleryMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gJtD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gmke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['cards', 'details'],
  // data: () => ({
  //   cards: [
  //     // { title: 'Sienna', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/sienna-header.jpg', flex: 12 },
  //     { title: 'Jade', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/jade-header.jpg', flex: 4 },
  //     { title: 'Sienna', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/sienna-header.jpg', flex: 4 },
  //     { title: 'Mia', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/mia-header.jpg', flex: 4 },
  //     { title: 'The Foundry', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/foundry.jpg', flex: 4 },
  //     { title: 'Landings', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/landings.jpg', flex: 4 },
  //     { title: 'Tiana', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/tiana-header.jpg', flex: 4 },
  //     { title: 'Tara', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/tara-header.jpg', flex: 4 },
  //     { title: 'Dockside', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/dockside.jpg', flex: 4 },
  //     { title: 'Lani', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/lani-header.jpg', flex: 4 }
  //   ]
  // }),
  data: function data() {
    return {
      cardFlex: 4
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    updateActiveProjectID: 'projects/updateActiveProjectID',
    updateActiveProjectName: 'projects/updateActiveProjectName',
    updateActiveProjectLocation: 'projects/updateActiveProjectLocation',
    updateActiveProjectDetails: 'projects/updateActiveProjectDetails'
  }), {
    showProject: function showProject(card) {
      this.getProjectDetails(card);
    },
    getProjectDetails: function getProjectDetails(project) {
      var _this = this;

      var path = '/project/' + project.id;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.updateActiveProjectDetails(response.data.project_details);
          _this.updateActiveProjectName(project.name);
          _this.updateActiveProjectLocation(project.location);
          _this.updateActiveProjectID(project.id);
          _this.$router.push('/works/' + project.name);
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    }
  })
});

/***/ }),

/***/ "gosb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("pFqp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48c420da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("dLe3");
function injectStyle (ssrContext) {
  __webpack_require__("kdXA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48c420da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48c420da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hTE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"x12":"","md8":"","lg6":""}},_vm._l((_vm.details.paragraphs),function(paragraph,index){return _c('div',{key:index},[(paragraph.title !== '')?_c('p',[_vm._v(_vm._s(paragraph.title))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"content-text"},[_vm._v(_vm._s(paragraph.description))])])}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hToL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hg+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Jumbotron_vue__ = __webpack_require__("Rnn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProjectsCard_vue__ = __webpack_require__("VS4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BuzzGallery__ = __webpack_require__("1ns2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BuzzTube__ = __webpack_require__("mO8d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isShowGallery: false,
      gallery: [],
      isShowVideo: false,
      videos: []
    };
  },
  beforeMount: function beforeMount() {
    this.getGalleryData();
    this.getVideoData();
  },

  components: {
    Jumbotron: __WEBPACK_IMPORTED_MODULE_0__components_Jumbotron_vue__["a" /* default */],
    ProjectsCard: __WEBPACK_IMPORTED_MODULE_1__components_ProjectsCard_vue__["a" /* default */],
    BuzzGallery: __WEBPACK_IMPORTED_MODULE_2__components_BuzzGallery__["a" /* default */],
    BuzzTube: __WEBPACK_IMPORTED_MODULE_3__components_BuzzTube__["a" /* default */]
  },
  methods: {
    // showVideo () {
    //   // this.$emit('showVideo')
    // },
    getGalleryData: function getGalleryData() {
      var _this = this;

      // console.log(projectID)
      var path = '/image-gallery';
      // const auth = {
      //   username: this.authUsername,
      //   password: this.authPassword
      // }
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(path).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.imagegallery[0].project_details)
          response.data.imagegallery.forEach(function (el) {
            // this.gallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name })
            _this.gallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name, 'project_details': el.project_details.headline });
          });
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal({
          'type': 'error',
          'title': error.toString().substring(0, 100)
        });
      });
    },
    getVideoData: function getVideoData() {
      var _this2 = this;

      var path = '/video-gallery';
      // const auth = {
      //   username: this.authUsername,
      //   password: this.authPassword
      // }
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(path).then(function (response) {
        if (response.data.status === 0) {
          _this2.videos = response.data.videos;
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "hmhj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ParallaxHeader__ = __webpack_require__("A+Hu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Design__ = __webpack_require__("CZ7n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      designData: [{ 'title': '', 'content': '' }],
      index: 0
    };
  },

  components: {
    ParallaxHeader: __WEBPACK_IMPORTED_MODULE_0__components_ParallaxHeader__["a" /* default */],
    Design: __WEBPACK_IMPORTED_MODULE_1__components_Design__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.getDesignData();
  },

  methods: {
    getDesignData: function getDesignData() {
      var _this = this;

      var path = '/design';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.designData = response.data.design;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "iwm3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"design-page"}},[_c('ParallaxHeader',{attrs:{"headline":'Design',"slogan":''}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl6":""}},[_c('v-tabs',{attrs:{"color":"grey lighten-2","left":""}},_vm._l((_vm.designData),function(design,designIndex){return _c('v-tab',{key:designIndex,on:{"click":function($event){_vm.index = designIndex}}},[_vm._v("\n            "+_vm._s(design.title)+"\n          ")])})),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('div',{staticClass:"design-div",attrs:{"dense":"","color":"grey lighten-2"}},[_c('h2',{staticClass:"display-2"},[_vm._v(_vm._s(_vm.designData[_vm.index].title)),_c('span',{attrs:{"clas":"inline-buzz-hr"}})]),_vm._v(" "),_c('hr',{staticClass:"buzz-hr"}),_vm._v(" "),_vm._l((_vm.designData[_vm.index].content.split('\n')),function(para,i){return _c('p',{key:i,staticClass:"content-text"},[_vm._v(_vm._s(para))])})],2)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.designData[_vm.index].image)?_c('v-card',[_c('v-card-media',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + _vm.designData[_vm.index].image,"height":"70vh"}})],1):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j+yj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jBqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AboutInputForm__ = __webpack_require__("8QNr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("n5Qe");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['buttonName', 'editData', 'projectId'],
  data: function data() {
    return {
      valid: true,
      title: '',
      titleRules: [function (v) {
        return !!v || 'Name is required';
      }],
      description: '',
      descriptionRules: [function (v) {
        return !!v || 'Description is required';
      }],
      imageFile: '',
      editDetailsData: null,
      experienceDetailsData: [],
      detailsButtonName: 'Add',
      showExperienceDetailsForm: false,
      menu2: false,
      headers: [{
        text: 'Title',
        align: 'left',
        sortable: false,
        value: 'detailTitle'
      }, { text: 'Content', align: 'right', value: 'content' }, { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' }, { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' }, { text: 'Edit', sortable: false, align: 'right', value: 'edit' }]
    };
  },

  components: {
    ExperienceDetailsForm: __WEBPACK_IMPORTED_MODULE_3__components_AboutInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (this.editData) {
      this.title = this.editData.title;
      this.description = this.editData.content;
      this.imageFile = 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + this.editData.image;
      this.experienceDetailsData = this.editData.experienceDetails;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  })),
  methods: {
    submit: function submit() {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          var data = {
            title: this.title,
            content: this.description,
            current_user: this.currentUser,
            experience_details: this.experienceDetailsData
          };
          var imageInput = this.$el.querySelector('#file');
          this.$emit('addItem', data, imageInput);
        }
      } else {
        if (this.$refs.form.validate()) {
          var _data = {
            title: this.title,
            content: this.description,
            current_user: this.currentUser,
            experience_details: this.experienceDetailsData
          };
          var _imageInput = this.$el.querySelector('#file');
          this.$emit('updateItem', this.editData.id, _data, _imageInput);
        }
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.imageFile = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function removeImage(e) {
      var imageInput = this.$el.querySelector('#file');
      imageInput.value = '';
      this.imageFile = '';
    },
    showAddForm: function showAddForm() {
      this.showExperienceDetailsForm = true;
      this.editDetailsData = null;
    },
    showNewDetailsItem: function showNewDetailsItem(data, imageFile) {
      this.showExperienceDetailsForm = false;
      data.headline = data.title;
      data.author = { 'email': '' };
      data.modified_on = '';
      this.experienceDetailsData.push(data);
    },
    showEditForm: function showEditForm(item) {
      this.showExperienceDetailsForm = true;
      this.editDetailsData = item;
    },
    showUpdatedDetailsItem: function showUpdatedDetailsItem(detailsId, data, imageFile) {
      var _this = this;

      this.showExperienceDetailsForm = false;
      data.headline = data.title;
      data.author = { 'email': '' };
      data.modified_on = '';
      this.experienceDetailsData.forEach(function (el) {
        if (el.id === detailsId) {
          _this.experienceDetailsData[_this.experienceDetailsData.indexOf(el)] = data;
        }
      });
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      this.experienceDetailsData.pop(item);
      var path = '/experience/' + this.editData.id + '/' + item.id;
      // console.log(path)
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this2.$swal(response.data.message);
          _this2.$emit('detailsDeleted');
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    }
  }
});

/***/ }),

/***/ "kFA9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kIk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    headline: {
      required: true,
      type: String,
      default: 'Headline'
    },
    slogan: {
      required: true,
      type: String,
      default: 'Slogan'
    },
    headerImg: {
      type: String,
      default: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/default-header.png'
    },
    headerHeight: {
      type: String,
      default: '450'
    }
  }
});

/***/ }),

/***/ "kTPe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SliderImageInputForm__ = __webpack_require__("vfuc");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: [],
      showAboutForm: false,
      editData: null,
      buttonName: 'Add'
    };
  },

  components: {
    InputForm: __WEBPACK_IMPORTED_MODULE_4__components_SliderImageInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getAboutData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getAboutData: function getAboutData() {
      var _this = this;

      var path = '/slider-images';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          _this.aboutData = response.data.sliderimages;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Add';
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Update';
      this.editData = item;
    },
    addItem: function addItem(data, imageFile) {
      var _this2 = this;

      var path = '/slider-images';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this2.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this2.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function (response) {
              if (response.data.status === 0) {
                _this2.$swal(response.data.message);
                _this2.showAboutForm = !_this2.showAboutForm;
                _this2.getAboutData();
              } else {
                _this2.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this2.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this2.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data, imageFile) {
      var _this3 = this;

      var path = '/slider-images/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this3.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth).then(function (response) {
            if (response.data.status === 0) {
              _this3.$swal(response.data.message);
              _this3.showAboutForm = !_this3.showAboutForm;
              _this3.getAboutData();
            } else {
              _this3.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this3.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item, index) {
      var _this4 = this;

      var path = '/slider-images/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this4.getAboutData();
          _this4.$swal(response.data.message);
        } else {
          _this4.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this4.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "kdXA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kmiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"jumbo-tron"}},[_c('v-carousel',{staticStyle:{"height":"100%"},attrs:{"hide-delimiters":""}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.name}},[_c('div',{staticClass:"left-bottom-gradient"})])})),_vm._v(" "),_c('div',{attrs:{"id":"absolute-container"}},[_c('v-layout',{staticStyle:{"margin-bottom":"3.5vmax"},attrs:{"align-end":""}},[_c('v-flex',[_c('div',[_c('span',{attrs:{"id":"slogan"}},[_vm._v("Pioneering luxury apartments since 1985.")])]),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"large":"","color":"primary"},on:{"click":_vm.showVideo}},[_c('v-icon',[_vm._v("fa-play-circle")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"9pt"}},[_vm._v("Play Video")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"large":"","color":""},on:{"click":function($event){_vm.$emit('showGallery')}}},[_c('v-icon',[_vm._v("fa-camera")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"9pt"}},[_vm._v("View Gallery")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l/1S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"experience-form"}},[_c('v-container',[(!_vm.showExperienceDetailsForm)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.titleRules,"label":"Name","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.descriptionRules,"label":"Description","required":"","textarea":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"file","name":"file"},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.imageFile)?_c('div',[_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.imageFile}}),_vm._v(" "),_c('v-icon',{on:{"click":_vm.removeImage}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green"},on:{"click":_vm.showAddForm}},[_vm._v("+ Add Experience Item")]),_c('br'),_vm._v(" "),(_vm.experienceDetailsData.length > 0 && !_vm.showExperienceDetailsForm)?_c('div',{staticStyle:{"width":"100%"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.experienceDetailsData,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.headline))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.content.substring(0, 100)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("dateTimeFormat")(props.item.modified_on)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.author.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"fa primary small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"},on:{"click":function($event){_vm.showEditForm(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"fa dark small mx-3 white--text",attrs:{"icon":"","color":"grey lighten-1"},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("highlight_off")])],1)],1)]}}])})],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1):_c('ExperienceDetailsForm',{attrs:{"formTitle":'Experience Item',"buttonName":_vm.detailsButtonName,"editData":_vm.editDetailsData},on:{"addItem":_vm.showNewDetailsItem,"updateItem":_vm.showUpdatedDetailsItem,"goBack":function($event){_vm.showExperienceDetailsForm = !_vm.showExperienceDetailsForm}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l/wR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-footer',{staticClass:"grey darken-4 pa-3",attrs:{"height":"auto"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","py-3":"","text-xs-center":"","white--text":""}},_vm._l((_vm.socialLinks),function(item,index){return (item.show)?_c('a',{key:index,attrs:{"href":item.link,"target":"_blank"}},[_c('v-btn',{staticClass:"fa dark small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"}},[_c('v-icon',{attrs:{"size":"18"}},[_vm._v(_vm._s(item.icon))])],1)],1):_vm._e()})),_vm._v(" "),_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.name,staticClass:"hidden-sm-and-down",attrs:{"color":"white","flat":"","small":""},on:{"click":function($event){_vm.$router.push(link.path)}}},[_vm._v("\n      "+_vm._s(link.name)+"\n    ")])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-3":"","text-xs-center":"","white--text":""}},[_c('img',{attrs:{"src":"https://cdnblobendpoint.azureedge.net/bezzina-static/img/bezzina-logo.png","id":"footer-logo"}}),_c('br'),_vm._v(" "),_c('CopyrightComponent')],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lje2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__ = __webpack_require__("8riQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1bbef54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__ = __webpack_require__("3xEq");
function injectStyle (ssrContext) {
  __webpack_require__("U1sW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1bbef54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1bbef54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ljm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CopyrightComponent_vue__ = __webpack_require__("RuZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      links: [{ name: 'Home', path: '/' }, { name: 'About Us', path: '/about' }, { name: 'Experience', path: '/experience' }, { name: 'Works', path: '/works' }, { name: 'Design', path: '/design' }, { name: 'Contact Us', path: '/contact' }],
      // icons: [{class: 'fa fa-facebook', color: 'indigo'}, {class: 'fa fa-twitter', color: 'blue'}, {class: 'fa fa-linkedin', color: 'primary'}, {class: 'fa fa-instagram', color: 'purple'}],
      rows: [{
        title: 'Bezzina',
        children: ['Experience', 'Works', 'Design']
      }],
      socialLinks: []
    };
  },
  components: {
    CopyrightComponent: __WEBPACK_IMPORTED_MODULE_0__CopyrightComponent_vue__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.getSocialLinks();
  },

  methods: {
    getSocialLinks: function getSocialLinks() {
      var _this = this;

      var path = '/social-links';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          // console.log(response.data.sociallinks)
          _this.socialLinks = response.data.sociallinks;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "lmbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-form',
  props: ['buttonName', 'editData', 'formTitle'],
  data: function data() {
    return {
      id: null,
      valid: true,
      title: '',
      titleRules: [function (v) {
        return !!v || 'Title is required';
      }],
      content: '',
      contentRules: [function (v) {
        return !!v || 'Content is required';
      }],
      imageFile: ''
    };
  },
  beforeMount: function beforeMount() {
    if (this.editData) {
      this.id = this.editData.id;
      this.title = this.editData.title ? this.editData.title : this.editData.headline;
      this.content = this.editData.content;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentUser: 'adminUser/getLoggedInUser'
  })),
  methods: {
    submit: function submit() {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          var data = {
            id: this.id,
            title: this.title,
            content: this.content,
            current_user: this.currentUser
          };
          var imageInput = this.$el.querySelector('#file');
          this.$emit('addItem', data, imageInput);
        }
      } else {
        if (this.$refs.form.validate()) {
          var _data = {
            id: this.id,
            title: this.title,
            content: this.content,
            current_user: this.currentUser
          };
          var _imageInput = this.$el.querySelector('#file');
          this.$emit('updateItem', this.editData.id, _data, _imageInput);
        }
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    goBack: function goBack() {
      this.$emit('goBack');
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.imageFile = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function removeImage(e) {
      var imageInput = this.$el.querySelector('#file');
      imageInput.value = '';
      this.imageFile = '';
    }
  }
});

/***/ }),

/***/ "lqHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"admin-homepage"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":"","lg5":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/about')}}},[_vm._v("About")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/design')}}},[_vm._v("Design")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/project')}}},[_vm._v("Project")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/experience')}}},[_vm._v("Experience")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/completed-dev')}}},[_vm._v("Completed Development")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/slider-images')}}},[_vm._v("Slider Images")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/image-gallery')}}},[_vm._v("Image Gallery")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/company-contact')}}},[_vm._v("Company Contact")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.$router.push('/admin/social-links')}}},[_vm._v("Social Links")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mO8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuzzTube_vue__ = __webpack_require__("Ckuf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a28d1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuzzTube_vue__ = __webpack_require__("w+Se");
function injectStyle (ssrContext) {
  __webpack_require__("03yh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65a28d1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuzzTube_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a28d1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuzzTube_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "myhQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n1O5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-dark text-white",attrs:{"id":"completeddevelopment"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.projects),function(item){return _c('v-flex',_vm._b({key:item.name,attrs:{"hover":"","xs12":"","sm6":""}},'v-flex',( _obj = {}, _obj[("xs" + (_vm.cardFlex * 3))] = true, _obj[("md" + _vm.cardFlex)] = true, _obj ),false),[_c('v-card',{attrs:{"hover":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"100%","text-align":"center","height":"15vh"}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.address))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.properties))]),_vm._v(" "),_c('div',[_vm._v("Completed "+_vm._s(_vm._f("longMonthYearFormat")(item.completed)))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange","icon":""}},[_c('v-icon',[_vm._v("share")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange","icon":""}},[_c('v-icon',[_vm._v("info")])],1)],1)],1)],1)
var _obj;}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n5Qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.xsrfCookieName = 'csrftoken';
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.xsrfHeaderName = 'X-CSRFToken';

var ROOT_API = 'http://localhost:5000/api/v1';
if (true) {
  ROOT_API = '/api/v1';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(api, auth) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(ROOT_API + api, { auth: auth }).then(function (res) {
      return res;
    }).catch(function (res) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    });
  },
  post: function post(api, data, auth) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(ROOT_API + api, data, { auth: auth }).then(function (res) {
      return res;
    }).catch(function (res) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    });
  },
  put: function put(api, data, auth) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(ROOT_API + api, data, { auth: auth }).then(function (res) {
      return res;
    }).catch(function (res) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    });
  },
  delete: function _delete(api, params, auth) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(ROOT_API + api, { params: params, auth: auth }).then(function (res) {
      return res;
    }).catch(function (res) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    });
  }
});

/***/ }),

/***/ "nUEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"registration-form"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.nameRules,"label":"Username","counter":64,"required":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.emailRules,"label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.passwordRules,"append-icon":_vm.e1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1)},"type":_vm.e1 ? 'password' : 'text',"name":"input-10-1","label":"Password","hint":"At least 8 characters","min":"8","counter":"","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.password2Rules,"append-icon":_vm.e2 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2)},"type":_vm.e2 ? 'password' : 'text',"name":"input-10-2","label":"Confirm password","hint":"At least 8 characters","min":"8","counter":"","required":""},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Submit")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nVH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationComponent_vue__ = __webpack_require__("K07q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9f0ff80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationComponent_vue__ = __webpack_require__("K55/");
function injectStyle (ssrContext) {
  __webpack_require__("DKRO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9f0ff80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "njSA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ParallaxHeader__ = __webpack_require__("A+Hu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ImageGallery__ = __webpack_require__("MXg3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("n5Qe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tabInfo: true,
      tabGallery: false,
      tabs: [{ name: 'Info', tab: 'tab-info' }, { name: 'Gallery', tab: 'tab-gallery' }],
      paraIndex: 0,
      gallery: [],
      imageGallery: [],
      detailsGallery: [],
      showDetailsGallery: false,
      headerImg: ''
    };
  },
  beforeMount: function beforeMount() {
    this.updateActiveProjectName(this.$route.path.split('/')[2]);
    this.getGalleryData(this.projectID);
    // console.log(this.projectDetails)
  },

  components: {
    ParallaxHeader: __WEBPACK_IMPORTED_MODULE_1__components_ParallaxHeader__["a" /* default */],
    ImageGallery: __WEBPACK_IMPORTED_MODULE_2__components_ImageGallery__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    projectID: 'projects/getActiveProjectID',
    getProjectName: 'projects/getActiveProjectName',
    getProjectLocation: 'projects/getActiveProjectLocation',
    projectDetails: 'projects/getActiveProjectDetails'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    updateActiveProjectName: 'projects/updateActiveProjectName'
  }), {
    showTab: function showTab(tabName) {
      if (tabName === 'tab-info') {
        this.tabInfo = true;
        this.tabGallery = false;
      } else if (tabName === 'tab-gallery') {
        this.tabInfo = false;
        this.tabGallery = true;
      }
    },
    getGalleryData: function getGalleryData(projectID) {
      var _this = this;

      // console.log(projectID)
      var path = '/image-gallery/' + projectID;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.imagegallery[0].project_details)
          _this.imageGallery = response.data.imagegallery;
          response.data.imagegallery.forEach(function (el) {
            // this.gallery.push('https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name)
            _this.gallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name, 'project_details': el.project_details.headline });
          });
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showDetailsTab: function showDetailsTab(itemIndex, detailsID) {
      var _this2 = this;

      this.detailsGallery = [];
      this.imageGallery.forEach(function (el) {
        if (el.project_details.id === detailsID) {
          // this.detailsGallery.push('https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name)
          _this2.detailsGallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name, 'project_details': el.project_details.headline });
        }
      });
      if (this.detailsGallery.length > 0) {
        this.showDetailsGallery = true;
      } else {
        this.showDetailsGallery = false;
      }
      this.paraIndex = itemIndex;
    }
  })
});

/***/ }),

/***/ "o8lp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceInputForm_vue__ = __webpack_require__("jBqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea1336c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceInputForm_vue__ = __webpack_require__("l/1S");
function injectStyle (ssrContext) {
  __webpack_require__("u7p3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ea1336c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea1336c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oVeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"projects-page"}},[_c('ParallaxHeader',{attrs:{"headline":'Projects',"slogan":''}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl6":""}},[_c('v-tabs',{attrs:{"color":"grey lighten-2","left":""}},_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.name,on:{"click":function($event){_vm.showTab(tab.tab)}}},[_vm._v("\n            "+_vm._s(tab.name)+"\n          ")])})),_vm._v(" "),(_vm.tabAll)?_c('Projects',{attrs:{"cards":_vm.projects}}):_c('CompletedDevelopments')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oguP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-form"}},[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('input',{attrs:{"type":"file","id":"file","name":"file","required":""},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.imageFile)?_c('div',[_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.imageFile}}),_vm._v(" "),_c('v-icon',{on:{"click":_vm.removeImage}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "on22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-form"}},[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.titleRules,"label":"Title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.contentRules,"label":"Content","textarea":""},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"file","name":"file"},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.imageFile)?_c('div',[_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.imageFile}}),_vm._v(" "),_c('v-icon',{on:{"click":_vm.removeImage}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pFqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-form',
  data: function data() {
    return {
      e1: true,
      valid: true,
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      password: '',
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    login: 'adminUser/login',
    updateAuthData: 'adminUser/updateAuthData'
  }), {
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var path = '/admin/login';
        var data = {
          email: this.email,
          password: this.password
        };
        this.$swal({
          title: 'Signing In',
          onOpen: function onOpen() {
            // let that = this
            _this.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post(path, data).then(function (response) {
              if (response.data.status === 0 || response.data.status === 2) {
                _this.login(response.data.current_user).then(function () {
                  _this.updateAuthData(response.data.api_data);
                  _this.clear();
                  _this.$swal(response.data.message);
                  _this.$router.push('/admin');
                });
              } else {
                _this.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this.$swal.isLoading();
          }
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  })
});

/***/ }),

/***/ "pWHN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":"","lg5":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('h2',{staticClass:"headline"},[_vm._v("Sign in")]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Please fill out and submit the form below")]),_vm._v(" "),_c('LoginForm')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qNOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashBoardNav_vue__ = __webpack_require__("1qR1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2585ce86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashBoardNav_vue__ = __webpack_require__("xC3G");
function injectStyle (ssrContext) {
  __webpack_require__("0W1d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashBoardNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2585ce86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashBoardNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qTRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AboutInputForm__ = __webpack_require__("8QNr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: [],
      showAboutForm: false,
      editData: null,
      buttonName: 'Add'
    };
  },

  components: {
    AboutInputForm: __WEBPACK_IMPORTED_MODULE_4__components_AboutInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getAboutData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getAboutData: function getAboutData() {
      var _this = this;

      var path = '/about';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          _this.aboutData = response.data.about;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Add';
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Update';
      this.editData = item;
    },
    addItem: function addItem(data, imageFile) {
      var _this2 = this;

      var path = '/about';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this2.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this2.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth).then(function (response) {
              if (response.data.status === 0) {
                _this2.$swal(response.data.message);
                _this2.showAboutForm = !_this2.showAboutForm;
                _this2.getAboutData();
              } else {
                _this2.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this2.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this2.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data, imageFile) {
      var _this3 = this;

      var path = '/about/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this3.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth).then(function (response) {
            if (response.data.status === 0) {
              _this3.$swal(response.data.message);
              _this3.showAboutForm = !_this3.showAboutForm;
              _this3.getAboutData();
            } else {
              _this3.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this3.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item, index) {
      var _this4 = this;

      var path = '/about/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this4.getAboutData();
          _this4.$swal(response.data.message);
        } else {
          _this4.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this4.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "qV5V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qbg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DESIGN_TABS; });
var DESIGN_TABS = [{
  name: 'Interior',
  paragraphs: [{
    title: '',
    description: 'There is one overwhelming constant in Bezzina’s approach to development – the location inspires the design. Because we take so much care in selecting our waterfront properties it is only natural that our apartments should pay homage to the surroundings.'
  }, {
    title: '',
    description: 'It guarantees also that each property is unique, the clean elegant lines of the architecture responding to its environment. The result is a style of architecture that looks right in its place, offering a daily reminder that life is indeed good.'
  }, {
    title: '',
    description: 'Our preference for natural materials, sandstone, marble and timber, and our deference to the craft of the artisan, lends a feeling of permanence and warmth to our apartments, a rare feat in a machine age.'
  }]
}, {
  name: 'Landscape'
}, {
  name: 'Materials'
}, {
  name: 'Lifestyle'
}];

/***/ }),

/***/ "qpZp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r9pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Image Gallery")]),_vm._v(" "),(!_vm.showAboutForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.projectData.length > 0 && !_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-tabs',{attrs:{"color":"grey lighten-2","left":""}},_vm._l((_vm.projectData),function(item,i){return _c('v-tab',{key:i,on:{"click":function($event){_vm.activeProject = i}}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])})),_vm._v(" "),(_vm.projectDetailsData.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","lg3":""}},[_c('v-card',[_c('v-list',{staticClass:"grey lighten-3"},_vm._l((_vm.projectDetailsData),function(item,itemIndex){return _c('v-list-tile',{key:itemIndex,on:{"click":function($event){_vm.showDetailsTab(itemIndex, item.id)}}},[_c('v-list-tile-action',[(_vm.paraIndex === itemIndex)?_c('v-icon',[_vm._v("star")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-title',{staticStyle:{"text-transform":"uppercase","font-size":"10pt","font-weight":"bold","color":"#676767","margin-left":"-20px"},domProps:{"textContent":_vm._s(item.headline)}})],1)}))],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getImagePerPage),function(image,imgIndex){return (_vm.aboutData.length > 0)?_c('v-flex',{key:imgIndex,attrs:{"x2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',{staticStyle:{"position":"relative"}},[_c('img',{staticStyle:{"width":"200px","height":"200px"},attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + image.name}}),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified on: "+_vm._s(_vm._f("dateTimeFormat")(image.modified_on)))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified by: "+_vm._s(image.author.email))]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","dark":""},on:{"click":function($event){_vm.deleteItem(image, imgIndex)}}},[_c('v-icon',[_vm._v("highlight_off")]),_vm._v("Remove")],1)],1)],1)],1):_vm._e()})),_vm._v(" "),(_vm.aboutData.length === 0)?_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('v-card',[_c('v-card-title',[_vm._v("\n                    No Images\n                    ")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-pagination',{attrs:{"length":Math.ceil(_vm.aboutData.length/_vm.imagesPerPage),"circle":""},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)],1)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('MultipleImageInputForm',{attrs:{"buttonName":_vm.buttonName},on:{"addItem":_vm.addItem,"goBack":function($event){_vm.showAboutForm = !_vm.showAboutForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rhlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"project-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Project")]),_vm._v(" "),(!_vm.showProjectForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.projectData.length > 0 && !_vm.showProjectForm)?_c('v-flex',{attrs:{"xs12":"","md9":"","offset-md3":"","offset-lg1":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.projectData,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.location))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.gross_realisation))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("yearFormat")(props.item.completed_on)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("dateTimeFormat")(props.item.modified_on)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.author.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"fa primary small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"},on:{"click":function($event){_vm.showEditForm(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"fa dark small mx-3 white--text",attrs:{"icon":"","color":"grey lighten-1"},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("highlight_off")])],1)],1)]}}])})],1):_vm._e(),_vm._v(" "),(_vm.showProjectForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('ProjectInputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"detailsDeleted":_vm.getProjectData,"goBack":function($event){_vm.showProjectForm=!_vm.showProjectForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sHjE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sQi3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__ = __webpack_require__("0Obf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c17c9292_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__ = __webpack_require__("pWHN");
function injectStyle (ssrContext) {
  __webpack_require__("teQs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c17c9292"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c17c9292_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "skJ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md2":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Slider Images")]),_vm._v(" "),(!_vm.showAboutForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.aboutData),function(item,index){return (_vm.aboutData.length > 0 && !_vm.showAboutForm)?_c('v-flex',{key:index,attrs:{"xs2":"","offset-md2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('img',{staticStyle:{"max-width":"250px","max-height":"250px"},attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.name}}),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified on: "+_vm._s(_vm._f("dateTimeFormat")(item.modified_on)))]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Modified by: "+_vm._s(item.author.email))]),_vm._v(" "),_c('v-btn',{staticClass:"dark small mx-3 white--text",attrs:{"color":"black","round":""},on:{"click":function($event){_vm.deleteItem(item)}}},[_c('v-icon',[_vm._v("highlight_off")]),_vm._v(" Remove\n            ")],1)],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.showAboutForm)?_c('v-flex',{attrs:{"xs12":"","offset-md2":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('InputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"goBack":function($event){_vm.showAboutForm = !_vm.showAboutForm}}})],1)],1)],1):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "spE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-form"}},[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"Name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":("Youtube Video?: " + (_vm.isYoutubeLink.toString()))},model:{value:(_vm.isYoutubeLink),callback:function ($$v) {_vm.isYoutubeLink=$$v},expression:"isYoutubeLink"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Youtube Link"},model:{value:(_vm.youtubeLink),callback:function ($$v) {_vm.youtubeLink=$$v},expression:"youtubeLink"}}),_vm._v(" \n    Thumbnail "),_c('input',{attrs:{"type":"file","id":"file","name":"file","required":""},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.imageFile)?_c('div',[_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.imageFile}}),_vm._v(" "),_c('v-icon',{on:{"click":_vm.removeImage}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v("\n    Video "),_c('input',{attrs:{"type":"file","id":"videofile","name":"videofile","required":""},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.videoFile)?_c('div',[(!_vm.isYoutubeLink)?_c('video',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.videoFile}}):_c('iframe',{attrs:{"width":"560","height":"315","src":_vm.youtubeLink,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}}),_vm._v(" "),_c('v-icon',{on:{"click":_vm.removeImage}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sy1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletedDevMenuItem_vue__ = __webpack_require__("V5/V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce2f8676_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompletedDevMenuItem_vue__ = __webpack_require__("HnH7");
function injectStyle (ssrContext) {
  __webpack_require__("50zn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce2f8676"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletedDevMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce2f8676_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompletedDevMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tQtI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tZkX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "teQs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u2ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("n5Qe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ 'name': 'default-header.jpg' }]
    };
  },
  mounted: function mounted() {
    this.getImagesData();
  },

  methods: {
    showVideo: function showVideo() {
      this.$emit('showVideo');
    },
    getImagesData: function getImagesData() {
      var _this = this;

      var path = '/slider-images';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          _this.items = response.data.sliderimages;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "u7p3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uv19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VideoGalleryInputForm__ = __webpack_require__("KEw5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: [],
      showAboutForm: false,
      editData: null,
      buttonName: 'Add'
    };
  },

  components: {
    InputForm: __WEBPACK_IMPORTED_MODULE_4__components_VideoGalleryInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getAboutData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getAboutData: function getAboutData() {
      var _this = this;

      var path = '/video-gallery';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.aboutData = response.data.videos;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Add';
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Update';
      this.editData = item;
    },
    addItem: function addItem(data, imageFile, videoFile) {
      var _this2 = this;

      var path = '/video-gallery';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('video', videoFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this2.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this2.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function (response) {
              if (response.data.status === 0) {
                _this2.$swal(response.data.message);
                _this2.showAboutForm = !_this2.showAboutForm;
                _this2.getAboutData();
              } else {
                _this2.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this2.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this2.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data, imageFile, videoFile) {
      var _this3 = this;

      var path = '/video-gallery/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('video', videoFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this3.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth).then(function (response) {
            if (response.data.status === 0) {
              _this3.$swal(response.data.message);
              _this3.showAboutForm = !_this3.showAboutForm;
              _this3.getAboutData();
            } else {
              _this3.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this3.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item) {
      var _this4 = this;

      var path = '/video-gallery/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this4.getAboutData();
          _this4.$swal(response.data.message);
        } else {
          _this4.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this4.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "v3cX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay-gallery"},[_c('div',{staticClass:"overall-bottom-gradient",on:{"click":function($event){_vm.$emit('showGallery')}}}),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-card',{attrs:{"dark":"","color":"black"}},[(_vm.images.length > 0)?_c('v-card-media',{directives:[{name:"touch",rawName:"v-touch",value:({
                  left: function () { return _vm.handleRightClick(); },
                  right: function () { return _vm.handleLeftClick(); }
                  }),expression:"{\n                  left: () => handleRightClick(),\n                  right: () => handleLeftClick()\n                  }"}],attrs:{"src":_vm.images[_vm.activeImage].image,"height":"70vmin","contain":""}},[_c('div',{staticClass:"left-bottom-gradient"}),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"focus",rawName:"v-focus"}],attrs:{"id":"hidden-input"},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39,$event.key)){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.handleKeyUp($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key)){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.handleKeyUp($event)}],"blur":function($event){_vm.handleBlurEvent()}}})]),_vm._v(" "),_c('p',{staticClass:"img-project-title"},[_vm._v(_vm._s(_vm.images[_vm.activeImage].project)+" - "+_vm._s(_vm.images[_vm.activeImage].project_details))]),_vm._v(" "),_c('v-icon',{attrs:{"id":"slide-left","large":""},on:{"click":function($event){_vm.handleLeftClick()}}},[_vm._v("fa fa-angle-left")]),_vm._v(" "),_c('v-icon',{attrs:{"id":"slide-right","large":""},on:{"click":function($event){_vm.handleRightClick()}}},[_vm._v("fa fa-angle-right")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-icon',{attrs:{"id":"close-slide","large":"","color":"white"},on:{"click":function($event){_vm.$emit('showGallery')}}},[_vm._v("highlight_off")])],1)],1)],1),_vm._v(" "),_c('p',{staticStyle:{"color":"white"}},[_c('span',[_vm._v(_vm._s(_vm.activeImage + 1))]),_vm._v("/"),_c('span',[_vm._v(_vm._s(_vm.images.length))])]),_vm._v(" "),_c('v-layout',{staticStyle:{"position":"relative"},attrs:{"row":"","wrap":"","id":"thumbnail-div","justify-center":""}},[_c('v-icon',{staticClass:"hidden-sm-and-down",attrs:{"id":"page-slide-left","large":"","color":"white"},on:{"click":function($event){_vm.pageDown()}}},[_vm._v("fa fa-angle-left")]),_vm._v(" "),_c('v-icon',{staticClass:"hidden-sm-and-down",attrs:{"id":"page-slide-right","large":"","color":"white"},on:{"click":function($event){_vm.pageUp()}}},[_vm._v("fa fa-angle-right")]),_vm._v(" "),_vm._l((_vm.getImagesPerPage),function(item,index){return _c('div',{key:index,staticClass:"hidden-sm-and-down gallery-thumbnail",on:{"click":function($event){_vm.showImage(index)}}},[_c('img',{attrs:{"src":item.image}}),_vm._v(" "),(_vm.showOpacity(index))?_c('div',{attrs:{"id":"overlay"}}):_vm._e()])})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vfuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SliderImageInputForm_vue__ = __webpack_require__("AWFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_744bffec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SliderImageInputForm_vue__ = __webpack_require__("oguP");
function injectStyle (ssrContext) {
  __webpack_require__("G366")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-744bffec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SliderImageInputForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_744bffec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SliderImageInputForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w+Se":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay-gallery"},[_c('div',{staticClass:"overall-bottom-gradient",on:{"click":function($event){_vm.$emit('showVideo')}}}),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-card',{attrs:{"dark":"","color":"black","height":"70vmin"}},[(_vm.videos.length > 0 && !_vm.videos[_vm.activeVideo].is_youtube_link)?_c('video',{attrs:{"width":"100%","height":"100%","controls":"","autoplay":"","src":'https://cdnblobendpoint.azureedge.net/bezzina-static/video/' + _vm.videos[_vm.activeVideo].video}},[_vm._v("\n                  HTML5 video not supported by this browser\n                ")]):_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.videos[_vm.activeVideo].youtube_link,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}}),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"focus",rawName:"v-focus"}],attrs:{"id":"hidden-input"},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39,$event.key)){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.handleKeyUp($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key)){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.handleKeyUp($event)}],"blur":function($event){_vm.handleBlurEvent()}}})]),_vm._v(" "),_c('v-icon',{attrs:{"id":"slide-left","large":""},on:{"click":function($event){_vm.handleLeftClick()}}},[_vm._v("fa fa-angle-left")]),_vm._v(" "),_c('v-icon',{attrs:{"id":"slide-right","large":""},on:{"click":function($event){_vm.handleRightClick()}}},[_vm._v("fa fa-angle-right")])],1)],1)],1),_vm._v(" "),_c('v-icon',{attrs:{"id":"close-slide","large":"","color":"white"},on:{"click":function($event){_vm.$emit('showVideo')}}},[_vm._v("highlight_off")])],1)],1)],1),_vm._v(" "),_c('p',{staticStyle:{"color":"white"}},[_c('span',[_vm._v(_vm._s(_vm.activeVideo + 1))]),_vm._v("/"),_c('span',[_vm._v(_vm._s(_vm.videos.length))])]),_vm._v(" "),_c('v-layout',{staticStyle:{"position":"relative"},attrs:{"row":"","wrap":"","id":"thumbnail-div","justify-center":""}},[_c('v-icon',{staticClass:"hidden-sm-and-down",attrs:{"id":"page-slide-left","large":"","color":"white"},on:{"click":function($event){_vm.pageDown()}}},[_vm._v("fa fa-angle-left")]),_vm._v(" "),_c('v-icon',{staticClass:"hidden-sm-and-down",attrs:{"id":"page-slide-right","large":"","color":"white"},on:{"click":function($event){_vm.pageUp()}}},[_vm._v("fa fa-angle-right")]),_vm._v(" "),_vm._l((_vm.getVideosPerPage),function(item,index){return _c('div',{key:index,staticClass:"hidden-sm-and-down gallery-thumbnail",on:{"click":function($event){_vm.showVideo(index)}}},[_c('img',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.thumbnail}}),_vm._v(" "),(_vm.showOpacity(index))?_c('div',{attrs:{"id":"overlay"}}):_vm._e()])})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wCbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__("MfHO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da4e3bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__("+VUi");
function injectStyle (ssrContext) {
  __webpack_require__("7JSO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3da4e3bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da4e3bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wRjz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wUKj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wwrJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"social-link-form"}},[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.nameRules,"label":"Name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.iconRules,"label":"Icon Name","required":""},model:{value:(_vm.icon),callback:function ($$v) {_vm.icon=$$v},expression:"icon"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.linkRules,"label":"Link","required":""},model:{value:(_vm.link),callback:function ($$v) {_vm.link=$$v},expression:"link"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":("Show Icon: " + (_vm.showIcon.toString()))},model:{value:(_vm.showIcon),callback:function ($$v) {_vm.showIcon=$$v},expression:"showIcon"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x7AD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("2ccQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c890dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("Cq4C");
function injectStyle (ssrContext) {
  __webpack_require__("zCoc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28c890dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c890dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xC3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"psr-navbar"},[_c('v-toolbar',{staticClass:"teal darken-4",attrs:{"dark":"","dense":"","fixed":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('img',{staticStyle:{"width":"150px","height":"40px","margin-left":"1vw"},attrs:{"src":"https://cdnblobendpoint.azureedge.net/bezzina-static/img/bezzina-logo.png","alt":"Bezzina"},on:{"click":function($event){_vm.$router.push('/')}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_vm._l((_vm.links),function(link,index){return _c('v-btn',{key:index,attrs:{"slot":"activator","flat":""},on:{"click":function($event){_vm.$router.push(link.path)}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(link.icon))]),_vm._v(_vm._s(link.name)+"\n      ")],1)}),_vm._v(" "),(_vm.isLoggedIn)?_c('v-btn',{attrs:{"slot":"activator","flat":""},on:{"click":function($event){_vm.$router.push('/admin/register')}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s("fa fa-user-plus"))]),_vm._v(" "+_vm._s("Register"))],1):_vm._e(),_vm._v(" "),(_vm.isLoggedIn)?_c('v-btn',{attrs:{"slot":"activator","flat":""},on:{"click":_vm.logoutUser},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s("fa fa-sign-out"))]),_vm._v(" "+_vm._s("Logout"))],1):_vm._e()],2)],1),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"hidden-md-and-up",attrs:{"temporary":"","fixed":"","floating":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.$router.push(item.path)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavigationComponent_vue__ = __webpack_require__("nVH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterComponent_vue__ = __webpack_require__("ydGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DashBoardNav__ = __webpack_require__("qNOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DashBoardFooter__ = __webpack_require__("3Yui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DashBoardNavDrawer__ = __webpack_require__("IifK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_util_easing_patterns__ = __webpack_require__("yobx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_util_easing_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_util_easing_patterns__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // isShowVideo: false
      type: 'number',
      number: 300,
      duration: 1000,
      offset: 0,
      easing: 'easeInOutCubic',
      easings: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_util_easing_patterns__)
    };
  },

  components: {
    NavigationComponent: __WEBPACK_IMPORTED_MODULE_1__components_NavigationComponent_vue__["a" /* default */],
    FooterComponent: __WEBPACK_IMPORTED_MODULE_2__components_FooterComponent_vue__["a" /* default */],
    DashBoardNav: __WEBPACK_IMPORTED_MODULE_3__components_DashBoardNav__["a" /* default */],
    DashBoardFooter: __WEBPACK_IMPORTED_MODULE_4__components_DashBoardFooter__["a" /* default */],
    DashBoardNavDrawer: __WEBPACK_IMPORTED_MODULE_5__components_DashBoardNavDrawer__["a" /* default */]
  },
  watch: {
    $route: function $route() {
      var _this = this;

      if (this.$route.path === '/' || this.$route.path.indexOf('admin') !== -1) {
        this.$vuetify.goTo(0, this.options);
      } else {
        this.$vuetify.goTo(0, { duration: 500, offset: 0, easing: 'easeInOutCubic' });
        setTimeout(function () {
          _this.$vuetify.goTo(_this.target, _this.options);
        }, 501);
      }
    }
  },
  computed: {
    target: function target() {
      var value = this[this.type];
      if (!isNaN(value)) return Number(value);else return value;
    },
    options: function options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      };
    }
  }
  // methods: {
  //   showVideo () {
  //     this.isShowVideo = !this.isShowVideo
  //   }
  // }
});

/***/ }),

/***/ "xiLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectDetailPage_vue__ = __webpack_require__("njSA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f906ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectDetailPage_vue__ = __webpack_require__("/din");
function injectStyle (ssrContext) {
  __webpack_require__("SDxu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04f906ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectDetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f906ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectDetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yL51":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yQ7t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yctl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MultipleImageInputForm__ = __webpack_require__("9vnh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aboutData: [],
      showAboutForm: false,
      buttonName: 'Add',
      projectData: [],
      projectDetails: [],
      activeProject: 0,
      paraIndex: 0,
      page: 1,
      imagesPerPage: 9,
      activeProjectID: '',
      activeDetailsID: ''
    };
  },

  components: {
    MultipleImageInputForm: __WEBPACK_IMPORTED_MODULE_4__components_MultipleImageInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getProjectData();
    }
  },

  watch: {
    activeProject: function activeProject() {
      this.aboutData = [];
      this.paraIndex = 0;
      this.page = 1;
      this.activeProjectID = '';
      this.activeDetailsID = '';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  }), {
    projectDetailsData: function projectDetailsData() {
      return this.getProjectDetails();
    },
    getImagePerPage: function getImagePerPage() {
      return this.aboutData.slice((this.page - 1) * this.imagesPerPage, this.imagesPerPage * this.page);
    }
  }),
  methods: {
    getProjectDetails: function getProjectDetails() {
      var _this = this;

      var details = [];
      if (this.projectDetails.length > 0) {
        this.projectDetails.forEach(function (el) {
          if (el.project.id === _this.projectData[_this.activeProject].id) {
            details.push(el);
          }
        });
      }
      return details;
    },
    getProjectData: function getProjectData() {
      var _this2 = this;

      var path = '/project';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this2.projectData = response.data.project;
          _this2.projectDetails = response.data.project_details;
        } else {
          _this2.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this2.$swal(error.toString().substring(0, 100));
      });
    },
    getAboutData: function getAboutData(projectID, projectDetailsID) {
      var _this3 = this;

      var path = '/image-gallery/' + projectID + '/' + projectDetailsID;
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          // console.log(response.data.about)
          // console.log(response.data)
          _this3.aboutData = response.data.imagegallery;
        } else {
          _this3.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this3.$swal(error.toString().substring(0, 100));
      });
    },
    showDetailsTab: function showDetailsTab(itemIndex, detailsID) {
      this.page = 1;
      this.activeDetailsID = detailsID;
      this.paraIndex = itemIndex;
      this.activeProjectID = this.projectData[this.activeProject].id;
      this.getAboutData(this.activeProjectID, detailsID);
    },
    showAddForm: function showAddForm() {
      this.showAboutForm = !this.showAboutForm;
      this.buttonName = 'Add';
    },
    addItem: function addItem(data, imageFile) {
      var _this4 = this;

      var path = '/image-gallery';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      var imageFileArr = [];
      for (var i = 0; i < imageFile.files.length; i++) {
        imageFileArr.push(imageFile.files[i]);
      }
      [].forEach.call(imageFile.files, function (file, index) {
        formData.append('image' + index, file);
      });
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this4.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this4.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function (response) {
              if (response.data.status === 0) {
                _this4.$swal(response.data.message);
                _this4.showAboutForm = !_this4.showAboutForm;
                _this4.getAboutData();
              } else {
                _this4.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this4.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this4.$swal.isLoading();
          }
        });
      });
    },
    deleteItem: function deleteItem(item, index) {
      var _this5 = this;

      var path = '/image-gallery/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this5.getAboutData(_this5.activeProjectID, _this5.activeDetailsID);
          _this5.$swal(response.data.message);
        } else {
          _this5.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this5.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "ydGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterComponent_vue__ = __webpack_require__("ljm7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a22ad84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterComponent_vue__ = __webpack_require__("l/wR");
function injectStyle (ssrContext) {
  __webpack_require__("sHjE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a22ad84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a22ad84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yft2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"experience-page"}},[_c('ParallaxHeader',{attrs:{"headline":'Experience',"slogan":''}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl6":""}},[_c('v-tabs',{attrs:{"color":"grey lighten-2","left":""}},_vm._l((_vm.experienceData),function(experience,experienceIndex){return _c('v-tab',{key:experienceIndex,on:{"click":function($event){_vm.showExperienceItem(experienceIndex, experience)}}},[_vm._v("\n            "+_vm._s(experience.title)+"\n          ")])})),_vm._v(" "),(_vm.experienceDetails.length === 0 || _vm.experienceData[_vm.index].title.toLowerCase() === 'videos')?_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.experienceData[_vm.index].title.toLowerCase() !== 'videos')?_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('div',{staticClass:"experience-div",attrs:{"dense":"","color":"grey lighten-2"}},[_c('h2',{staticClass:"display-2"},[_vm._v(_vm._s(_vm.experienceData[_vm.index].title))]),_vm._v(" "),_c('hr',{staticClass:"buzz-hr"}),_vm._v(" "),_vm._l((_vm.experienceData[_vm.index].content.split('\n')),function(para,i){return _c('p',{key:i,staticClass:"content-text"},[_vm._v(_vm._s(para))])})],2)]):_vm._e(),_vm._v(" "),(_vm.experienceData[_vm.index].title.toLowerCase() !== 'videos')?_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.experienceData[_vm.index].image)?_c('v-card',[_c('v-card-media',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + _vm.experienceData[_vm.index].image,"height":"70vh"}})],1):_vm._e()],1):_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"experience-div",attrs:{"dense":"","color":"grey lighten-2"}},[_c('h2',{staticClass:"display-2"},[_vm._v(_vm._s(_vm.experienceData[_vm.index].title))]),_vm._v(" "),_c('hr',{staticClass:"buzz-hr"}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.videos),function(item,i){return _c('v-flex',_vm._b({key:i,on:{"click":function($event){_vm.showVideo(i)}}},'v-flex',( _obj = {}, _obj[("xs" + (3 * 2))] = true, _obj[("sm" + (3))] = true, _obj[("md" + (3))] = true, _obj[("lg" + (3))] = true, _obj ),false),[_c('v-card',{attrs:{"hover":"","raised":"","height":"150"}},[_c('v-card-media',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.thumbnail,"height":"150"}})],1)],1)
var _obj;}))],1),_vm._v(" "),(_vm.showVideoGallery)?_c('BuzzTube',{attrs:{"videos":_vm.videos,"activeIndex":_vm.videoIndex},on:{"showVideo":function($event){_vm.showVideoGallery=!_vm.showVideoGallery}}}):_vm._e()],1)])],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-card',[_c('v-list',{staticClass:"grey lighten-3 hidden-sm-and-down"},_vm._l((_vm.experienceDetails),function(item,itemIndex){return _c('v-list-tile',{key:itemIndex,on:{"click":function($event){_vm.showDetailsTab(itemIndex, item.id)}}},[_c('v-list-tile-action',[(_vm.paraIndex === itemIndex)?_c('v-icon',[_vm._v("star")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-title',{staticStyle:{"text-transform":"uppercase","font-size":"10pt","font-weight":"bold","color":"#676767","margin-left":"-20px"},domProps:{"textContent":_vm._s(item.headline)}})],1)}))],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('div',[_c('p',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.experienceDetails[_vm.paraIndex].headline)+" \n                  ")]),_c('div',{staticClass:"hidden-md-and-up"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-icon',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("fa-ellipsis-h")]),_vm._v(" "),_c('v-list',{staticClass:"grey lighten-2"},_vm._l((_vm.experienceDetails),function(item,itemIndex){return _c('v-list-tile',{key:itemIndex,on:{"click":function($event){_vm.showDetailsTab(itemIndex, item.id)}}},[_c('v-list-tile-action',[(_vm.paraIndex === itemIndex)?_c('v-icon',[_vm._v("star")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-title',{staticStyle:{"text-transform":"uppercase","font-size":"10pt","font-weight":"bold","color":"#676767"},domProps:{"textContent":_vm._s(item.headline)}})],1)}))],1)],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('hr',{staticClass:"buzz-hr"}),_vm._v(" "),(!_vm.showDetailsGallery)?_c('div',[_vm._l((_vm.experienceDetails[_vm.paraIndex].content.split('\n')),function(para,i){return _c('p',{key:i,staticClass:"content-text"},[_vm._v(_vm._s(para))])}),_vm._v(" "),_c('v-card-media',{attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + _vm.experienceData[_vm.index].image,"height":"35vh"}})],2):_c('ImageGallery',{attrs:{"thumbnail":_vm.detailsGallery}}),_vm._v(" "),_c('v-spacer')],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yp8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ExperienceInputForm__ = __webpack_require__("o8lp");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      experienceData: [],
      showExperienceForm: false,
      editData: null,
      buttonName: 'Save',
      experienceDetailsData: [],
      headers: [{
        text: 'Experience',
        align: 'left',
        sortable: false,
        value: 'experience'
      },
      // { text: 'Title', value: 'Title' },
      { text: 'Description', value: 'Description' }, { text: 'Modified On', sortable: false, align: 'right', value: 'modifiedOn' }, { text: 'Modified By', sortable: false, align: 'right', value: 'modifiedBy' }, { text: 'Edit', sortable: false, align: 'right', value: 'edit' }]
    };
  },

  components: {
    ExperienceInputForm: __WEBPACK_IMPORTED_MODULE_4__components_ExperienceInputForm__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    if (!this.loginStatus) {
      this.$router.push('/admin/login');
    } else {
      this.getExperienceData();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    loginStatus: 'adminUser/getLoginStatus',
    currentUser: 'adminUser/getLoggedInUser',
    authUsername: 'adminUser/getAuthUser',
    authPassword: 'adminUser/getAuthPassword'
  })),
  methods: {
    getExperienceData: function getExperienceData() {
      var _this = this;

      var path = '/experience';
      var auth = {
        username: this.authUsername,
        password: this.authPassword
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get(path, auth).then(function (response) {
        if (response.data.status === 0) {
          _this.experienceData = response.data.experience;
          _this.experienceDetailsData = response.data.experience_details;
        } else {
          _this.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this.$swal(error.toString().substring(0, 100));
      });
    },
    showAddForm: function showAddForm() {
      this.showExperienceForm = !this.showExperienceForm;
      // this.buttonName = 'Save'
      this.editData = null;
    },
    showEditForm: function showEditForm(item) {
      var _this2 = this;

      this.showExperienceForm = !this.showExperienceForm;
      // this.buttonName = 'Update'
      this.editData = item;
      this.editData.experienceDetails = [];
      this.experienceDetailsData.forEach(function (el) {
        if (el.experience.id === item.id) {
          _this2.editData.experienceDetails.push(el);
        }
      });
    },
    addItem: function addItem(data, imageFile) {
      var _this3 = this;

      var path = '/experience';
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$nextTick(function () {
        _this3.$swal({
          title: 'Adding Item',
          onOpen: function onOpen() {
            _this3.$swal.showLoading();
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function (response) {
              if (response.data.status === 0) {
                _this3.$swal(response.data.message);
                _this3.showExperienceForm = !_this3.showExperienceForm;
                _this3.getExperienceData();
              } else {
                _this3.$swal(response.data.message);
              }
            }).catch(function (error) {
              _this3.$swal(error.toString().substring(0, 100));
            });
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this3.$swal.isLoading();
          }
        });
      });
    },
    editItem: function editItem(itemId, data, imageFile) {
      var _this4 = this;

      var path = '/experience/' + itemId;
      var auth = { username: this.authUsername, password: this.authPassword };
      var formData = new FormData();
      formData.append('image', imageFile.files[0]);
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$swal({
        title: 'Updating Item',
        onOpen: function onOpen() {
          _this4.$swal.showLoading();
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put(path, formData, auth, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (response) {
            if (response.data.status === 0) {
              _this4.$swal(response.data.message);
              _this4.showExperienceForm = !_this4.showExperienceForm;
              _this4.getExperienceData();
            } else {
              _this4.$swal(response.data.message);
            }
          }).catch(function (error) {
            _this4.$swal(error.toString().substring(0, 100));
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this4.$swal.isLoading();
        }
      });
    },
    deleteItem: function deleteItem(item) {
      var _this5 = this;

      var path = '/experience/' + item.id;
      var params = {
        current_user: this.currentUser
      };
      var auth = { username: this.authUsername, password: this.authPassword };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete(path, params, auth).then(function (response) {
        if (response.data.status === 0) {
          _this5.getExperienceData();
          _this5.$swal(response.data.message);
        } else {
          _this5.$swal(response.data.message);
        }
      }).catch(function (error) {
        _this5.$swal(error.toString().substring(0, 100));
      });
    }
  }
});

/***/ }),

/***/ "yrgc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"design-page"}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Design")]),_vm._v(" "),(!_vm.showDesignForm)?_c('v-btn',{staticClass:"primary",staticStyle:{"margin-bottom":"18px"},attrs:{"round":"","icon":""},on:{"click":_vm.showAddForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.designData.length > 0 && !_vm.showDesignForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.designData,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.content.substring(0, 100)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('img',{staticStyle:{"max-width":"100px","max-height":"100px"},attrs:{"src":'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + props.item.image}})]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("dateTimeFormat")(props.item.modified_on)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.author.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"fa primary small mx-3 white--text",attrs:{"icon":"","color":"grey darken-2"},on:{"click":function($event){_vm.showEditForm(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"fa dark small mx-3 white--text",attrs:{"icon":"","color":"grey lighten-1"},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("highlight_off")])],1)],1)]}}])})],1):_vm._e(),_vm._v(" "),(_vm.showDesignForm)?_c('v-flex',{attrs:{"xs12":"","offset-md3":"","offset-lg2":""}},[_c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-container',[_c('AboutInputForm',{attrs:{"buttonName":_vm.buttonName,"editData":_vm.editData},on:{"addItem":_vm.addItem,"updateItem":_vm.editItem,"goBack":function($event){_vm.showDesignForm = !_vm.showDesignForm}}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zCoc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zQ5M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zhgA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zqzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"hidden-sm-and-down",attrs:{"permanent":"","dark":"","clipped":"","width":"200"}},[_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.$router.push(item.path)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zuhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-form"}},[_c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-select',{attrs:{"items":_vm.projectItems,"label":"Select Experience Item","single-line":""},model:{value:(_vm.projectSelected),callback:function ($$v) {_vm.projectSelected=$$v},expression:"projectSelected"}}),_vm._v(" "),(_vm.projectSelected)?_c('v-select',{attrs:{"items":_vm.projectDetailsItems,"label":"Select Experience Detail Item","single-line":""},model:{value:(_vm.projectDetailsSelected),callback:function ($$v) {_vm.projectDetailsSelected=$$v},expression:"projectDetailsSelected"}}):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"file","name":"file","multiple":""},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.imageFile)?_c('div',[_c('img',{staticStyle:{"max-width":"300px","max-height":"300px"},attrs:{"src":_vm.imageFile}}),_vm._v(" "),_c('v-icon',{on:{"click":_vm.removeImage}},[_vm._v("fa-times")])],1):_vm._e(),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.buttonName))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1fd0ad6b91cc38810281.js